import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Grid,
  Hidden,
  Icon,
  IconButton,
  Input,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  alpha,
  AppBar,
  Toolbar,
  InputBase,
  InputAdornment,
  Backdrop,
  LinearProgress,
  Snackbar,
  useMediaQuery,
  Collapse, 
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { makeStyles, styled } from "@mui/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import clsx from "clsx";
import CustomDatePicker from "../utilities/CustomDatePicker";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddContainerDialog from "./AddContainer";
import DeleteIcon from "@mui/icons-material/Delete";
import data from "./data";
import ViewContainer from "./ViewContainer";
import EditContainer from "./EditContainer";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import FuseUtils from "@fuse/utils/FuseUtils";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import { hasShowroom, toShowroomIdList } from "../utilities/showroomUtils";
import BookingRequestDialog from "./BookingRequest";
import ContainerForm from "./containerForm";
import { padding } from "@mui/system";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import moment from "moment";
import { CheckBoxSharp, PanoramaFishEyeSharp } from "@mui/icons-material";
import { uniq } from "lodash";
import { SelectShippingType } from "../order/order-list/celleditor-component/EditorComponent";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import Draggable from 'react-draggable';
import { checkABNumber } from "../utilities/FormValidation";
import { utils, writeFile } from "xlsx-js-style";
import FormPageHeader from "../utilities/FormPageHeader";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import TableViewIcon from '@mui/icons-material/TableView';
import { blue, grey } from "@mui/material/colors";
import ContainerTablePreview from "./ContainerTablePreview";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
// import InfiniteScroll from 'react-infinite-scroll-component';
const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "4px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  fontSize: "12px",

  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },
  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,

    "& .file": {
      cursor: "not-allowed",
    },
  },
  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    "& .order-detail-summary": {
      flexDirection: "row",
      display: "flex",
      flexWrap: "wrap",

      "& li": {
        padding: "5px 0",
        width: "50%",
        display: "flex",
        alignItems: "center",

        "& label": {
          display: "inline-block",
          width: "167px",
        },
      },
    },
    "& .FusePageSimple-content": {
      position: "absolute",
      overflow: "auto",
      height: "calc(100%)",
    },
    "& .container-filter": {
      background: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    "& .total-container": {
      background: theme.palette.background.paper,
      borderRadius: 8,
      padding: 10,
    },
    "& .selected-container": {
      background: theme.palette.action.selected,
      borderRadius: 8,
      padding: 10,
    },
    "& .width-120": {
      width: 115,
    },
    "& .active-container": {
      background: `${theme.palette.action.selected} !important`,
    },
  },
}));



const sortAndFilter = (allOfTheData, sortModel, filterModel) => {
  return sortData(sortModel, filterData(filterModel, allOfTheData));
};

const sortData = (sortModel, data) => {
  const sortPresent = sortModel && sortModel.length > 0;
  if (!sortPresent) {
    return data;
  }
  // do an in memory sort of the data, across all the fields
  const resultOfSort = data.slice();
  resultOfSort.sort(function (a, b) {
    for (let k = 0; k < sortModel.length; k++) {
      const sortColModel = sortModel[k];
      const valueA = a[sortColModel.colId];
      const valueB = b[sortColModel.colId];
      // this filter didn't find a difference, move onto the next one
      if (valueA == valueB) {
        continue;
      }
      const sortDirection = sortColModel.sort === "asc" ? 1 : -1;
      if (valueA > valueB) {
        return sortDirection;
      } else {
        return sortDirection * -1;
      }
    }
    // no filters found a difference
    return 0;
  });
  return resultOfSort;
};

const filterData = (filterModel, data) => {
  const filterPresent = filterModel && Object.keys(filterModel).length > 0;
  if (!filterPresent) {
    return data;
  }
  const resultOfFilter = [];
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (filterModel.age) {
      const age = item.age;
      const allowedAge = parseInt(filterModel.age.filter);
      // EQUALS = 1;
      // LESS_THAN = 2;
      // GREATER_THAN = 3;
      if (filterModel.age.type == "equals") {
        if (age !== allowedAge) {
          continue;
        }
      } else if (filterModel.age.type == "lessThan") {
        if (age >= allowedAge) {
          continue;
        }
      } else {
        if (age <= allowedAge) {
          continue;
        }
      }
    }
    if (filterModel.year) {
      if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
        // year didn't match, so skip this record
        continue;
      }
    }
    if (filterModel.country) {
      if (filterModel.country.values.indexOf(item.country) < 0) {
        continue;
      }
    }
    resultOfFilter.push(item);
  }
  return resultOfFilter;
};

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlans}`;
const getContainersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlan}`;
const containersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.container}`;
const cityUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}`;
const updateForwarderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.addForwarderDetails}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const portsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ports}`;
const lacquaredUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const loadingWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryInfoes}`;
const findByKitchenUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findByKitchen}`;
const bookingRequestUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.bookingRequestMail}`;
const releaseRequestUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.releaseRequestMail}`;
const orderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const containerIdUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getSequenceNumber}`;
const getMyOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getMyOrders}`;
const containerOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getOrdersForContainers}`;
const getDateUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getDateFromyear}`;
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], button'}
      disabled={isMobile}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
const ContainerList = (props) => {
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const hasEditRole = ["ROLE_ORDERPRO", "ROLE_SOPDIR", "ROLE_ADMIN", "ROLE_PARTNER_ADMIN"].some(role =>
    token.scope.includes(role)
  );
  const hasSuperRole = ["ROLE_ORDERPRO", "ROLE_SOPDIR", "ROLE_ADMIN", "ROLE_MD"].some(role =>
    token.scope.includes(role)
  );
  const hasPartnerAdminRole = ["ROLE_PARTNER_ADMIN"].some(role =>
    token.scope.includes(role)
  );
  const hasPartnerOrderProRole = ["ROLE_PARTNRORDPROCESS"].some((role) =>
    token.scope.includes(role)
  );
  const hasPartnerShwMngrRole = ["ROLE_SHWRMMGR"].some((role) =>
    token.scope.includes(role)
  );
  const hasMDRole = ["ROLE_MD"].some((role) =>
    token.scope.includes(role)
  );
  const hasIAMRole = token?.scope?.includes("ROLE_IAM") && !(token?.scope?.includes("ROLE_ADMIN") || token?.scope?.includes("ROLE_SOPDIR"));
  const hasLogisticsRole = ["ROLE_LOGIMGR", "ROLE_LOGISTICS"].some(role =>
    token.scope.includes(role)
  );
  const hasPartnersRole = [
    "ROLE_PARTNER",
    "ROLE_PARTNER_ADMIN",
    // "ROLE_SHWRMMGR",
    "ROLE_PARTNRDESIGN",
    // "ROLE_PARTNRORDPROCESS",
  ].some((role) => token?.scope?.includes(role));

  const perPage = 10;
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    []
  );
  const classes = useStyles(props);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [containerRowData, setContainerRowData] = useState([]);
  const [containerPlanList, setContainerPlanList] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [pendingOrderChanges, setPendingOrderChanges] = useState(null);
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalAllVolume, setTotalAllVolume] = useState(0);
  const [vendor, setVendor] = useState("-");
  const [btnDisable, setBtnDisable] = useState(false);
  const gridRef = useRef();
  const gridRefPrev = useRef();
  const dropZoneRefs = useRef(new Map());

  const [error, setError] = useState("");
  const [expanded, setExpanded] = useState("panel1");
  const [draggedRow, setDraggedRow] = useState(null);
  const [anchorCardMenu, setAnchorCardMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openViewContainer, setOpenViewContainer] = useState(false);
  const [openEditContainer, setOpenEditContainer] = useState(false);
  const [openContainerForm, setOpenContainerForm] = useState(false);
  const [openBookingRequest, setOpenBookingRequest] = useState(false);
  const [openWarningAlert, setOpenWarningAlert] = useState(false);
  const [openWarningAlertContainerStatus, setOpenWarningAlertContainerStatus] = useState(false);
  const [openWarningAlertVolume, setOpenWarningAlertVolume] = useState(false);
  const [newOrder, setNewOrder] = useState([]);
  const [bookingContainer, setBookingContainer] = useState([]);
  const [region, setRegion] = useState({ value: "Riyadh", label: "Riyadh" });
  const [containerType, setContainerType] = useState([]);
  const [alreadyBookedContainer, setAlreadyBookedContainer] = useState([]);
  const [btnDisableBooking, setBtnDisableBooking] = useState(false);
  const [abNumber, setAbNumber] = useState("");
  const [projectRef, setProjectRef] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorsList, setErrorsList] = useState([]);
  const [expLoadingWeek, setExpLoadingWeek] = useState({
    value: "40",
    label: "40",
  });
  const [forwarder, setForwarder] = useState({
    name: "",
    contact: "",
    email: "",
  });
  const [comment, setComment] = useState();
  const [editRegion, setEditRegion] = useState(false);
  const [editContainerType, setEditContainerType] = useState(false);
  const [editExpLoadingWeek, setEditExpLoadingWeek] = useState(false);
  const [editForwarder, setEditForwarder] = useState(false);
  const [editComment, setEditComment] = useState(false);
  const openCardMenu = Boolean(anchorCardMenu);
  const open = Boolean(anchorEl);
  const openBooking = Boolean(anchorE2);
  const openApproval = Boolean(anchorE3);
  const [containerTypeOptions, setContainerTypeOptions] = useState([]);
  const [defContainerTypeOptions, setDefContainerTypeOptions] = useState([]);
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const [defLoadingWeekOptions, setDefLoadingWeekOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [companiesOptions, setCompaniesOptions] = useState([]);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [newContainer, setNewContainer] = useState([]);
  const [activeContainer, setActiveContainer] = useState(null);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [lacqueredRanges, setLacqueredRanges] = useState([]);
  const [isValidLoadingWeeks, setIsValidLoadingWeeks] = useState(false);
  const [uniqueLoadingWeek, setUniqueLoadingWeek] = useState();
  const [uniqueLoadingYear, setUniqueLoadingYear] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
    const [isOpenTable, setIsOpenTable] = useState(false);
const [openError, setOpenError] = useState(false);
const [creatingContainers, setCreatingContainers] = useState(false);
const [progress, setProgress] = useState(0);
const navigate = useNavigate();
const ordersPanelVisible = isOpen && !isMobile && !hasLogisticsRole;

const useTopFilters =
  hasLogisticsRole || isMobile || (hasSuperRole && !isOpen);
const [filter, setFilter] = useState(() => {
  const savedFilter = sessionStorage.getItem("orderFilter");

  if (savedFilter) {
    return {
      ...JSON.parse(savedFilter),
      pageSize: 50,
    };
  } else {
    const currentDate = new Date();

    const fourMonthsAgo = new Date(currentDate);
    fourMonthsAgo.setMonth(currentDate.getMonth() - 12);

    const fourMonthsLater = new Date(currentDate);
    fourMonthsLater.setMonth(currentDate.getMonth() + 4);

    const formattedDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const isFromDashboard =
      sessionStorage.getItem("pathName") === "/order/dashboard";

    if (hasLogisticsRole) {
      return {
        fromDate: formattedDate(fourMonthsAgo),
        toDate: formattedDate(fourMonthsLater),
        pageNo: 0,
        pageSize: 12,
        abNumber: "",
        projectRef: "",
      };
    }

    return {
      status: isFromDashboard ? "BOOKING_REQUEST_SENT_TO_NFZE" : "",
      fromDate: formattedDate(fourMonthsAgo),
      toDate: formattedDate(fourMonthsLater),
      pageNo: 0,
      pageSize: 10,
      abNumber: "",
      projectRef: "",
    };
  }
});
const [filterPagination, setFilterPagination] = useState(() => {
  const savedFilter = sessionStorage.getItem("orderFilter");

  if (savedFilter) {
    return {
      ...JSON.parse(savedFilter),
      pageSize: 50,
    };
  } else {
    const currentDate = new Date();

    const fourMonthsAgo = new Date(currentDate);
    fourMonthsAgo.setMonth(currentDate.getMonth() - 12);

    const fourMonthsLater = new Date(currentDate);
    fourMonthsLater.setMonth(currentDate.getMonth() + 4);

    const formattedDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const isFromDashboard =
      sessionStorage.getItem("pathName") === "/order/dashboard";

    if (hasLogisticsRole) {
      return {
        fromDate: formattedDate(fourMonthsAgo),
        toDate: formattedDate(fourMonthsLater),
        pageNo: 0,
        pageSize: 12,
        abNumber: "",
        projectRef: "",
      };
    }

    return {
      status: isFromDashboard ? "BOOKING_REQUEST_SENT_TO_NFZE" : "",
      fromDate: formattedDate(fourMonthsAgo),
      toDate: formattedDate(fourMonthsLater),
      pageNo: 0,
      pageSize: 10,
      abNumber: "",
      projectRef: "",
    };
  }
});

const [fromDate, setFromDate] = useState(null);
const [toDate, setToDate] = useState(null);
const [containerCount, setContainerCount] = useState(0);
const [totalContainerCount, setTotalContainerCount] = useState(0);
const [controller, setController] = useState({
  pageSize: 10,
  pageNo: 0,
});
// const [page, setPage] = useState(1);
const [containers, setContainers] = useState([]);
const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [bookingApiEndpoint, setBookingApiEndpoint] = useState("");
  const [currentWeek, setCurrentWeek] = useState();
  const [loadingWeekData, setLoadingWeekData] = useState([]);
  const [filteredLoadingWeek, setFilteredLoadingWeek] = useState([])
  const [openDeleteModel, setOpenDeleteModel] = useState(false)
  const [deleteContainerData, setDeleteContainerData] = useState()
  const [bookingComment, setBookingComment] = useState("");
  const [hasMixed, setHasMixed] = useState(false);
  const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
  const stateRef = useRef();
  const saveGridStateName = 'containerList';

  const [selectedCompanyId, setSelectedCompanyId] = useState()
  const currentYear = new Date().getFullYear();

  const [selectedYear, setSelectedYear] = useState();
  const [selectedWeek, setSelectedWeek] = useState(null);

  const [yearOptions, setYearOptions] = useState([]);
  const [weekOptions, setWeekOptions] = useState([]);
  const [openForwarderInfo, setOpenForwarderInfo] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchFlagPrj, setSearchFlagPrj] = useState(false);
  const [isCreated, setIsCreated] = useState(false);

  const handleContainerClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleBookingClick = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleApprovalClick = (event) => {
    setAnchorE3(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE2(null);
    setAnchorE3(null);
    setAnchorCardMenu(null);
  };
  const handleCardMenu = (event) => {
    setAnchorCardMenu(event.currentTarget);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setOpenViewContainer(false);
    // setOpenEditContainer(false);
    setOpenBookingRequest(false);
    setOpenWarningAlert(false);
    setOpenWarningAlertContainerStatus(false);
    setSelectedContainerIds([]);
    setBookingContainer([]);

  };
  const handleDialogCloseVolume = () => {
    setOpenWarningAlertVolume(false);
    getOrderList();

  };
  const handleDialogCloseForwarderInfo = () => {
    setOpenForwarderInfo(false);

  };
  const handleSendForwarderInfo = async (shouldClose = false) => {
    try {
      const containerNos = selectedContainerIds.map(
        (container) => container.containerNo
      );

      const payload = {
        containerNos,
        name: forwarder.name,
        contact: forwarder.contact,
        emailAddress: forwarder.email,
        ...(shouldClose && { closeContainer: true })
      };

      await OAuthService.patchData(updateForwarderUrl, payload);

      if (shouldClose) {
        toast.success(
          "Forwarder information submitted successfully and Containers are closed"
        );
      } else {
        toast.success("Forwarder information submitted successfully");
      }

      handleDialogCloseForwarderInfo();
      getContainerPlans();
      setSelectedContainerIds([]);
      setForwarder({});
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      handleDialogCloseForwarderInfo();
      setSelectedContainerIds([]);
      setForwarder({});
    }
  };

  const handleForwarderDetailsChange = (e) => {
    const { name, value } = e.target;
    setForwarder((prev) => ({
      ...prev,
      [name]: value
    }))
  }
  const handleEditDialogClose = () => {
    setOpenEditContainer(false);

    // Restore original orders if user cancels edit
    if (pendingOrderChanges?.containerId) {
      setContainerPlanList(prev =>
        prev.map(container => {
          if (container.id === pendingOrderChanges.containerId) {
            return { ...container, orders: pendingOrderChanges.previousOrders };
          }
          return container;
        })
      );
    }

    setPendingOrderChanges(null);
    setOpenEditContainer(false);
    getContainerPlans();
    getOrderList();
  };



  const handleConfirmEdit = () => {
    setPendingOrderChanges(null);
  };

  const handleContainerFormClose = () => {
    setOpenContainerForm(false);
    setNewOrder([]);
    getContainerPlans();
    getOrderList();
    setActiveStep(0);
    setFormData({});

  }
  const handleCloseDeleteModel = () => {
    setOpenDeleteModel(false)
  }
  const handleAddContainer = () => {
    setContainerTypeOptions(defContainerTypeOptions);
    setOpenDialog(true);
  };
  const REQUIRED_COLUMNS = [
    "Commission Name",
    "Container Sequencing",
    "Expected loading Week",
    "Expected loading Year",
    "Destination/ Region",
    "Mode of Shipment",
    "Container Type"
  ];
  const validateColumns = (rows) => {
    if (!rows || rows.length === 0) {
      throw new Error("Excel is empty or invalid format");
    }

    const headers = Object.keys(rows[0] || {});

    const missing = REQUIRED_COLUMNS.filter(
      (col) => !headers.includes(col)
    );

    if (missing.length > 0) {
      throw new Error(`Missing columns: ${missing.join(", ")}`);
    }
  };
  const validateRowData = (
    rows,
    rowData,
    containerTypeList,
    regionOptions
  ) => {
    const errors = [];

    rows.forEach((row) => {
      const commissionName = row["Commission Name"] || "Unknown";

      const orderMatch = rowData?.find(
        (rd) => rd.commissionName === commissionName
      );

      if (!orderMatch) {
        errors.push(`Commission Name "${commissionName}": No matching order found`);
      }

      const containerMatch = containerTypeList?.find(
        (ct) => ct.uniqueCode === row["Container Type"]
      );

      if (!containerMatch) {
        errors.push(
          `Commission Name "${commissionName}": Invalid Container Type (${row["Container Type"]})`
        );
      }

      const destinationValue = row["Destination/ Region"]?.toUpperCase();

      const destinationValid = regionOptions?.some(
        (opt) => opt.label.trim() === destinationValue.trim()
      );

      if (!destinationValid) {
        errors.push(
          `Commission Name "${commissionName}": Invalid Destination (${row["Destination/ Region"]})`
        );
      }

      REQUIRED_COLUMNS.forEach((col) => {
        if (!row[col]) {
          errors.push(
            `Commission Name "${commissionName}": ${col} is empty`
          );
        }
      });

    });
    const sequenceMap = {};

    rows.forEach((row) => {
      const sequence = row["Container Sequencing"]?.toString().trim();

      if (!sequence) return;

      if (!sequenceMap[sequence]) {
        sequenceMap[sequence] = [];
      }
      const orderMatch = rowData?.find(
        (rd) => rd.commissionName === row["Commission Name"]
      );
      sequenceMap[sequence].push({
        week: row["Expected loading Week"]?.toString().trim(),
        year: row["Expected loading Year"]?.toString().trim(),
        destination: row["Destination/ Region"]?.toString().trim(),
        shipmentMode: row["Mode of Shipment"]?.toString().trim(),
        containerType: row["Container Type"]?.toString().trim(),
        commissionName: row["Commission Name"] || "Unknown",
        country: orderMatch?.country?.trim()?.toUpperCase() || "",
      });
    });

    Object.entries(sequenceMap).forEach(([sequence, items]) => {
      const commissions = items
        .map((i) => i.commissionName)
        .join(", ");

      const uniqueWeeks = [...new Set(items.map((i) => i.week))];
      const uniqueYears = [...new Set(items.map((i) => i.year))];
      const uniqueDestinations = [
        ...new Set(items.map((i) => i.destination)),
      ];
      const uniqueShipmentModes = [
        ...new Set(items.map((i) => i.shipmentMode)),
      ];
      const uniqueContainerTypes = [
        ...new Set(items.map((i) => i.containerType)),
      ];
      const uniqueCountries = [
        ...new Set(items.map((i) => i.country)),
      ];

      const allIndia = uniqueCountries.length === 1 &&
        uniqueCountries[0] === "INDIA";
      const uniquePrefixes = [
        ...new Set(
          items.map((i) =>
            i.commissionName?.substring(0, 2).toUpperCase()
          )
        ),
      ];
      if (uniqueWeeks.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" has inconsistent Expected loading Week values for Commission Names: ${commissions}`
        );
      }

      if (uniqueYears.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" has inconsistent Expected loading Year values for Commission Names: ${commissions}`
        );
      }

      if (uniqueDestinations.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" has inconsistent Destination/ Region values for Commission Names: ${commissions}`
        );
      }

      if (uniqueShipmentModes.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" has inconsistent Mode of Shipment values for Commission Names: ${commissions}`
        );
      }
      if (!allIndia && uniquePrefixes.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" contains Commission Names from different customers (${uniquePrefixes.join(
            ", "
          )}) for Commission Names: ${commissions}`
        );
      }
      if (uniqueContainerTypes.length > 1) {
        errors.push(
          `Container Sequencing "${sequence}" has inconsistent Container Type values for Commission Names: ${commissions}`
        );
      }
    });

    return errors;
  };
  const readExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);

          const workbook = XLSX.read(data, {
            type: "array",
            bookVBA: true,
          });

          const sheetName = workbook.SheetNames.find(
            (name) => name.trim().toUpperCase() === "MASTER"
          );

          if (!sheetName) {
            reject("MASTER sheet not found in uploaded file");
            return;
          }

          const worksheet = workbook.Sheets[sheetName];

          const json = XLSX.utils.sheet_to_json(worksheet, {
            defval: "",
            raw: false,
          });
          if (!json || json.length === 0) {
            reject("MASTER sheet is empty or has no valid rows");
            return;
          }
          resolve(json);

        } catch (err) {
          reject(err);
        }
      };

      reader.onerror = reject;

      reader.readAsArrayBuffer(file);
    });
  };
  const handleExcelUploadToCreateContainers = async (event) => {
    setIsCreated(false);
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null;

    try {
      setLoadingExcel(true);
      const rows = await readExcelFile(file);

      validateColumns(rows);

      const validationErrors = validateRowData(
        rows,
        rowData,
        containerType,
        regionOptions,
      );

      if (validationErrors.length > 0) {
        setErrors(validationErrors);
        setOpenPreview(true);
        return;
      }

      const payloads = await processExcelData(rows, rowData, containerType);

      setPreviewData(payloads);
      setErrors([]);
      setOpenPreview(true);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);

      setErrorMessage(message);
      setOpenError(true);
    } finally {
      setLoadingExcel(false);
    }
  };
  const handleDownloadExcel = () => {
    if (!gridRefPrev.current) return;

    gridRefPrev.current.api.exportDataAsExcel({
      fileName: "Container_Preview.xlsx",
      sheetName: "Containers",
      processCellCallback: (params) => {
        if (params.column.getColId() === "commissionNames") {
          return params.value?.join(", ");
        }
        return params.value;
      },
    });
  };
  const handleConfirmUpload = async () => {
    setCreatingContainers(true);
    setProgress(0);

    const total = previewData.length;
    const updatedPreview = [];

    let errorList = [];

    for (let i = 0; i < total; i++) {
      const {
        sequence,
        commissionNames,
        totalVolume,
        isMixed,
        maxVolumeAllowed,
        minVolumeAllowed,
        isOverVolume,
        isUnderVolume,
        orderDetails,
        ...apiPayload
      } = previewData[i];

      try {
        const res = await OAuthService.addData(getContainersUrl, apiPayload);
        const createdData = res?.data;

        updatedPreview.push({
          ...previewData[i],
          containerNo: createdData?.containerNo,
          apiTotalVolume: createdData?.totalVolume,
          status: "SUCCESS",
          errorMessage: null,
        });
      } catch (error) {
        const message =
          error?.response?.data?.errorMessage || error.message;

        errorList.push(
          `Sequence ${sequence}: ${message}`
        );

        updatedPreview.push({
          ...previewData[i],
          status: "FAILED",
          errorMessage: message,
        });
      }

      setProgress(Math.round(((i + 1) / total) * 100));
    }

    setPreviewData(updatedPreview);

    if (errorList.length > 0) {
      setErrorsList(errorList);
      setSuccessMessage("");
    } else {
      setErrorsList([]);
      setSuccessMessage("All containers created successfully");
    }

    setIsCreated(true);
    setCreatingContainers(false);

    getContainerPlans();
    getOrderList();
    setActiveStep(0);
    setFormData({});
  };

  const handleReadyIssuePI = async () => {
    try {
      const containerId = selectedContainerIds.map((obj) => obj.id);

      await OAuthService.addData(`${getContainersUrl}/readyToPI`, containerId);
      toast.success("Container  PI status changed ")
      getContainerPlans();
      setSelectedContainerIds([])

    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
      setSelectedContainerIds([])
    }
  }
  const handleRevertPI = async () => {
    try {
      const containerId = selectedContainerIds.map((obj) => obj.id);

      await OAuthService.addData(`${getContainersUrl}/clearReadyToPI`, containerId);
      toast.success("Container PI status cleared ")
      getContainerPlans();
      setSelectedContainerIds([])

    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
      setSelectedContainerIds([])
    }
  }

  useEffect(() => {
    sessionStorage.removeItem("pathName");
  }, []);
  const showFixedValue = (props) => {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
      formattedNumbers = "";
    } else {
      if (props.colDef.field === "volume" || props.colDef.field === "weight") {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        }).format(props?.value);
      } else {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(props?.value);
      }
    }
    return <p>{`${formattedNumbers}`}</p>;
  };

  let statusOptions = []

  if (hasPartnerAdminRole || hasPartnerOrderProRole || hasPartnerShwMngrRole || hasIAMRole) {
    statusOptions = [
      { value: "", label: "All" },
      { value: "OPEN", label: "Open" },
      { value: "CLOSE", label: "Close" },
      {
        value: "BOOKING_REQUEST_SENT_TO_NFZE",
        label: "Booking request sent to NFZE",
      },
      { value: "BOOKING_REQUEST_SENT_TO_FACTORY", label: "Booking request sent to factory" },
      { value: "BOOKED", label: "Booked" },
      { value: "RELEASED", label: "Released" },
      { value: "LOADED", label: "Loaded" },
    ];
    // } else if(hasMDRole) {
    //   statusOptions = [
    //     { value: "PENDING", label: "Pending" },
    //     { value: "APPROVED", label: "Approved" },
    //     { value: "REJECT", label: "Rejected" },
    //   ];
  } else {
    statusOptions = [
      { value: "", label: "All" },
      { value: "OPEN", label: "Open" },
      { value: "CLOSE", label: "Close" },

      {
        value: "BOOKING_REQUEST_SENT_TO_NFZE",
        label: "Booking request sent to NFZE",
      },

      { value: "BOOKING_REQUEST_SENT_TO_FACTORY", label: "Booking request sent to factory" },
      { value: "BOOKED", label: "Booked" },
      { value: "RELEASED", label: "Released" },
      { value: "LOADED", label: "Loaded" },
    ];
  }
  const specialDiscountIcon = (params) => {
    const data = params?.data;
    if (!data) return null;

    const { commissionName, specialDiscountRequested, sdrStatus } = data;

    return (
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {commissionName}
        {sdrStatus === "APPROVED" ? (
          <FuseSvgIcon size={18} sx={{ color: theme.palette.success.main }}>
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : sdrStatus === "WAITING" || sdrStatus === "PENDING" ? (
          <FuseSvgIcon size={18} sx={{ color: theme.palette.error.main }}>
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : (
          ""
        )}
      </span>
    );
  };
  const proformaStatusOptions = [{ value: " READY_TO_PI", label: " READY_TO_PI" }, { value: "PI_ISSUED", label: "PI_ISSUED" },]
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      valueGetter: "node.rowIndex + 1",
      rowDrag:
        hasPartnerOrderProRole || hasPartnerShwMngrRole || hasIAMRole
          ? false
          : true,
      cellRenderer: (props) => {
        if (props.value !== undefined) {
          return props.value;
        } else {
          return (
            <img src="https://www.ag-grid.com/example-assets/loading.gif" />
          );
        }
      },
    },
    {
      field: "abNumber",
      headerName: "AB Number",
      // enableRowGroup: true,
    },
    {
      field: "commissionName",
      headerName: "Commission Name",
      cellRenderer: specialDiscountIcon,

      // enableRowGroup: true,
    },
    {
      field: "uniqueId",
      enableRowGroup: true,
      valueGetter: (params) => params.data?.uniqueId.toUpperCase(),
    },
    {
      field: "vendorShortKey",
      headerName: "Product",
      // enableRowGroup: true,
    },
    {
      field: "orderCategory",
      headerName: "Category",
      // enableRowGroup: true,
    },
    {
      field: "volume",
      enableRowGroup: true,
      cellRenderer: showFixedValue,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "weight", enableRowGroup: true, cellRenderer: showFixedValue,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },

    },
    { field: "customerName", headerName: "Customer", enableRowGroup: true },
    {
      field: "documentType",
      // enableRowGroup: true,
      headerName: "SO/AO",
    },
    {
      headerName: "Lacquered",
      valueGetter: (params) => {
        const { range1Id, range2Id, range3Id } = params.data || {};
        const lacqueredRanges = params.context?.lacqueredRanges || [];

        const isLacquered = [range1Id, range2Id, range3Id].some(
          (id) => id && lacqueredRanges.includes(id),
        );

        return isLacquered ? "Lacquered" : "";
      },
      // filter: "agTextColumnFilter",
      // filterParams: {
      //   filterOptions: ["contains"],
      //   defaultOption: "contains",
      // },
    },
    {
      field: "country",
      // enableRowGroup: true,
      headerName: "Country",
      // minWidth: 70,
    },
    {
      headerName: "Region / Zone",
      field: "region",
    },
    {
      field: "plannedLoadingWeek",
      headerName: "Loading Week",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
      // enableRowGroup: true,
      // minWidth: 70,
    },
    {
      headerName: "Mode of Shipping",
      field: "freightId",
      headerTooltip: "Mode of Shipping",

      cellEditor: SelectShippingType,
    },
    {
      field: "showroomName",
      headerName: "Showroom",
      // enableRowGroup: true,
      // minWidth: 70,
    },
    {
      field: "orderStatus",
      headerName: "Status",
      // enableRowGroup: true,
      // minWidth: 70,
    },
  ]);
  const baseColumns = [
    {
      headerName: "Sequence",
      field: "sequence",
      minWidth: 120,
    },
    {
      headerName: "Loading Week",
      field: "plannedLoadingWeek",
      minWidth: 100,
      filter: "agNumberColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      headerName: "Container Type",
      field: "actualContainerType",
      minWidth: 160,
      valueGetter: (params) =>
        params.data?.actualContainerType?.uniqueCode || "",
    },
    {
      headerName: "Destination",
      field: "destination",
      minWidth: 150,
    },
    {
      headerName: "Commission Names",
      field: "commissionNames",
      minWidth: 250,
      autoHeight: true,
      cellRenderer: (params) => {
        if (!params.value?.length) return null;

        return (
          <div style={{ maxHeight: 100, overflowY: "auto" }}>
            {params.value.map((name, i) => (
              <div key={i}>{name}</div>
            ))}
          </div>
        );
      },


    },
    {
      headerName: "Total Volume",
      field: "totalVolume",
      minWidth: 140,
      tooltipValueGetter: (params) => {
        const d = params.data;
        if (!d) return "";

        return `Min: ${d.minVolumeAllowed}, Max: ${d.maxVolumeAllowed}`;
      },
      valueFormatter: (params) =>
        params.value ? params.value.toFixed(2) : "0.00",
      cellStyle: (params) => {
        if (params.data?.isOverVolume) {
          return { backgroundColor: theme.palette.error.main };
        }

        return null;
      },
    },

    {
      headerName: "Volume Status",
      minWidth: 160,
      valueGetter: (params) => {
        if (params.data?.isOverVolume) return "EXCEEDS MAX";
        if (params.data?.isUnderVolume) return "BELOW MIN";
        return "OK";
      },
    },
    {
      headerName: "Orders Count",
      field: "orderIds",
      minWidth: 80,
      valueGetter: (params) => params.data.orderIds?.length || 0,
    },
  ];
  const createdColumns = [
    {
      headerName: "Container No",
      field: "containerNo",
      minWidth: 180,
    },

    {
      headerName: "Status",
      field: "status",
      minWidth: 120,
      cellStyle: (params) => {
        if (params.value === "FAILED") {
          return { color: theme.palette.error.main, fontWeight: "bold" };
        }
        if (params.value === "SUCCESS") {
          return { color: theme.palette.success.main, fontWeight: "bold" };
        }
        return null;
      },
    }
  ];
  const hasOverVolume = previewData?.length
    ? previewData.some((row) => row.isOverVolume)
    : false;
  const overVolumeCount = previewData?.filter(
    (row) => row.isOverVolume
  ).length;
  const previewColumnDefs = useMemo(() => {
    return isCreated
      ? [...baseColumns, ...createdColumns] // ✅ after API
      : baseColumns; // ✅ before API
  }, [isCreated]);
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: "agMultiColumnFilter",
      floatingFilter: true,
      resizable: true,
      flex: 1,
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    };
  }, []);

  const getRowId = useCallback(function (params) {
    return params.data.id;
  }, []);

  const onGridReady = (params) => {
    setGridParams(params.api);
  };
  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);
  const autoSizeAllColumns = () => {
    if (!gridRef.current) return;
    const allColumnIds = [];
    gridRef.current.columnApi.getColumns().forEach((col) => {
      allColumnIds.push(col.getColId());
    });
    gridRef.current.columnApi.autoSizeColumns(allColumnIds);
  };
  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(data.screenState.columnGroupState);
        }
      } catch (err) {
        console.error('Failed to load grid state:', err);
      }
    }

    autoSizeAllColumns();
  };
  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(`gridState-${saveGridStateName}`, JSON.stringify(stateRef.current));
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);
  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
    autoSizeAllColumns();
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };
  const getOrderList = async () => {
        gridParams?.showLoadingOverlay();
    let list = "";
    let orders = "";
    const getShowroomOrders = async () => {
      const showroomIds = toShowroomIdList(token?.showroom);
      const lists = await Promise.all(
        showroomIds.map((showroomId) =>
          OAuthService.getList(
            containerOrdersUrl + `?customerNum=${token?.company}&showroomId=${showroomId}&sort=desc`
          )
        )
      );
      return lists.flatMap((showroomList) => showroomList?.data || []);
    };
    if (!hasLogisticsRole) {


      try {
        if (token) {
          if (hasPartnerShwMngrRole) {
            orders = await getShowroomOrders();
          } else if (hasPartnerOrderProRole) {
            orders = await getShowroomOrders();
          }
          else if (hasPartnerAdminRole) {
            list = await OAuthService.getList(
              containerOrdersUrl + `?customerNum=${token?.company}&sort=desc`
            );
            orders = list?.data;
          } else if (filter?.companyId && filter?.companyId !== 'all') {
            list = await OAuthService.getList(
              containerOrdersUrl + `?customerNum=${filter?.companyId}&sort=desc`
            );
            orders = list?.data;
          }
          else {
            list = await OAuthService.getList(containerOrdersUrl);
            orders = list?.data;
          }
        }
        setRowData(orders);
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message)
        // setError(error.message);
      }finally{
          gridParams?.hideOverlay();
      }
    }
  };

  const getContainerPlans = async (updatedFilter = null) => {
    setLoading(true);
    const searchQuery = updatedFilter || filterPagination;
    if (searchQuery.companyId === 'all') {
      delete searchQuery.companyId;
    }

    try {
      const list = await OAuthService.getPostList(
        `${getContainersUrl}/getContainersByCriteria`,
        searchQuery,
      );
      const data = list?.data?.content;
      if (data.length === 0) {
        toast.warn("No containers found for selected criteria");
      }
      setContainerPlanList(data);
      setTotalContainerCount(list.data.totalElements);
      setContainerCount(list.data.totalPages);
    } catch (error) {
      // setError(error.message);
      toast.error(error?.response?.data?.errorMessage || error.message);
    } finally {
      setLoading(false);
    }
  };
  const getContainerTypeList = async () => {
    const containers = await OAuthService.getList(containersUrl);
    const containerType = containers.data?._embedded?.containers;
    // console.log('containerType', containerType)
    const containersData = containerType.map((container) => {
      return {
        value: container.containerId,
        label: container.uniqueCode,
        volume: container.maxVolume,
        shippingType: container.modeOfShipment,
      };
    });
    setContainerType(containerType);
    setContainerTypeOptions(containersData);
    setDefContainerTypeOptions(containersData);
  };
  const getStartDateOfWeek = async (year, week) => {
    const list = await OAuthService.getList(
      `${getDateUrl}?week=${week}&year=${year}`
    );
    return moment(list.data)
      .subtract(3, "weeks")
      .format("YYYY-MM-DD");
  };
  // const processExcelData = async (rows, rowData, containerTypeList) => {
  //   const grouped = {};

  //   rows.forEach((row) => {
  //     const seq = row["Container Sequencing"];

  //     if (!grouped[seq]) {
  //       grouped[seq] = [];
  //     }

  //     grouped[seq].push(row);
  //   });

  //   const payloads = [];

  //   for (const seq in grouped) {
  //     const groupRows = grouped[seq];
  //     const firstRow = groupRows[0];

  //     const week = firstRow["Expected loading Week"];
  //     const year = firstRow["Expected loading Year"];
  //     const shippingType = firstRow["Mode of Shipment"];
  //     const destination = firstRow["Destination/ Region"];
  //     const containerCode = firstRow["Container Type"];

  //     const commissionNames = groupRows.map(
  //       (row) => row["Commission Name"]
  //     );

  //     const orderIds = groupRows
  //       .map((row) => {
  //         const match = rowData?.find(
  //           (rd) => rd.commissionName === row["Commission Name"]
  //         );
  //         return match?.id;
  //       })
  //       .filter(Boolean);

  //     const uniqueOrderIds = [...new Set(orderIds)];

  //     const matchedRow = rowData?.find(
  //       (rd) => rd.commissionName === firstRow["Commission Name"]
  //     );

  //     const companyId = matchedRow?.customerNum;

  //     const actualContainerType = containerTypeList?.find(
  //       (ct) => ct.uniqueCode === containerCode
  //     );

  //     const totalVolume = groupRows.reduce((sum, row) => {
  //       return sum + Number(row["Vol"] || 0);
  //     }, 0);

  //     const cutOffDate = await getStartDateOfWeek(year, week);

  //     payloads.push({
  //       containerStatus: "OPEN",
  //       status: "OPEN",
  //       shippingType,
  //       plannedLoadingYear: year,
  //       plannedLoadingWeek: week,
  //       destination,
  //       companyId,
  //       orderIds: uniqueOrderIds,
  //       actualContainerType,
  //       cutOffDate,

  //       // 🔹 EXTRA (for preview only)
  //       sequence: seq,
  //       commissionNames,
  //       totalVolume
  //     });
  //   }

  //   return payloads;
  // };
  const processExcelData = async (rows, rowData, containerTypeList) => {
    const grouped = {};

    // 🔹 GROUP BY SEQUENCE
    rows.forEach((row) => {
      const seq = row["Container Sequencing"];
      if (!grouped[seq]) grouped[seq] = [];
      grouped[seq].push(row);
    });

    const payloads = [];

    for (const seq in grouped) {
      const groupRows = grouped[seq];
      const firstRow = groupRows[0];

      const week = firstRow["Expected loading Week"];
      const year = firstRow["Expected loading Year"];
      const shippingType = firstRow["Mode of Shipment"];
      const destination = firstRow["Destination/ Region"];
      const containerCode = firstRow["Container Type"];

      let hasEK = false;
      let hasNonEK = false;

      const orderDetails = [];

      // 🔹 MAP ORDERS + VOLUME + VENDOR
      groupRows.forEach((row) => {
        const match = rowData?.find(
          (rd) => rd.commissionName === row["Commission Name"]
        );

        if (!match) return;

        const vendor = match.vendorShortKey;
        const volume = Number(match.volume || 0);

        // vendor grouping logic
        if (vendor === "EK") {
          hasEK = true;
        } else if (["NK", "NN", "NE", "NS"].includes(vendor)) {
          hasNonEK = true;
        }

        orderDetails.push({
          orderId: match.id,
          volume,
          vendorShortKey: vendor,
        });
      });

      const uniqueOrderIds = [
        ...new Set(orderDetails.map((o) => o.orderId)),
      ];

      const commissionNames = groupRows.map(
        (row) => row["Commission Name"]
      );

      const totalVolume = orderDetails.reduce(
        (sum, o) => sum + o.volume,
        0
      );

      const isMixed = hasEK && hasNonEK;

      const matchedRow = rowData?.find(
        (rd) => rd.commissionName === firstRow["Commission Name"]
      );

      const companyId = matchedRow?.customerNum;

      const actualContainerType = containerTypeList?.find(
        (ct) => ct.uniqueCode === containerCode
      );

      const cutOffDate = await getStartDateOfWeek(year, week);

      // 🔹 VOLUME VALIDATION
      let maxVolumeAllowed = actualContainerType?.maxVolume;
      let minVolumeAllowed = actualContainerType?.minVolume;

      if (isMixed) {
        maxVolumeAllowed = actualContainerType?.mixedMaxVolume;
        minVolumeAllowed = actualContainerType?.mixedMinVolume;
      }

      const isOverVolume = totalVolume > maxVolumeAllowed;
      const isUnderVolume = totalVolume < minVolumeAllowed;

      payloads.push({
        containerStatus: "OPEN",
        status: "OPEN",
        shippingType,
        plannedLoadingYear: year,
        plannedLoadingWeek: week,
        destination,
        companyId,
        orderIds: uniqueOrderIds,
        actualContainerType,
        cutOffDate,

        // New
        sequence: seq,
        commissionNames,
        totalVolume,
        isMixed,
        maxVolumeAllowed,
        minVolumeAllowed,
        isOverVolume,
        isUnderVolume,
        orderDetails,
      });
    }

    return payloads;
  };
  const getLoadingWeekList = async () => {
    // const loadingWeek = await OAuthService.getList(loadingWeekUrl);
    const kitchenList = [
      'Express Kitchen (Normal Handle)',
      'Express Kitchen (SystemLine)',
      'Nolte Kitchen Lacquered',
      'Nolte Kitchen Non Lacquered',
      'Nolte Eco Lacquered',
      'Nolte Eco Non Lacquered',
      'Nolte Spa Lacquered',
      'Nolte Spa Non Lacquered',
      'Nolte Neo Lacquered',
      'Nolte Neo Non Lacquered'
    ]
    const res = await OAuthService.getList(loadingWeekUrl);
    const fineKitchenName = res.data?._embedded?.deliveryInfoes.filter(
      (deliveryInfo) => kitchenList.includes(deliveryInfo.kitchenName)
    );
    //  console.log('fineKitchenName', fineKitchenName)
    setFilteredLoadingWeek(fineKitchenName)
    const kitchenName = fineKitchenName.map((obj) => obj.kitchenName)
    const deliveryDate = new Date();
    const model = {
      kitchenNames: kitchenName,
      date: deliveryDate,
    };
    const loadingWeek = await OAuthService.addData(findByKitchenUrl, model);
    const week = loadingWeek.data;
    // console.log('week', week)
    const highestWeekObject = week.reduce((prev, current) =>
      prev.week > current.week ? prev : current
    );
    const weekData = [{
      value: highestWeekObject.week,
      label: `${highestWeekObject.week}/${highestWeekObject?.year}`,
      id: highestWeekObject.deliveryDate,
    }];
    // const weekData = week.map((container) => {
    //   return {
    //     value: container.week,
    //     label: `${container.week}/${new Date(
    //       container?.deliveryDate
    //     ).getFullYear()}`,
    //     id: container.deliveryDate,
    //   };
    // });
    setLoadingWeekData(week);
    // setLoadingWeekOptions(weekData);
    setDefLoadingWeekOptions(weekData);

  };

  // const getStatusList = async() => {
  //   const list = containerPlanList.map(item => item.containerStatus)
  //   const uniqueStatus = [...new Set(list)];
  //   setStatusOptions(
  //     uniqueStatus.map(item => {
  //       return {
  //         value: item,
  //         label: item
  //       }
  //     })
  //   )
  // }

  const getFilterLoadingWeekList = async () => {
    const list = containerPlanList.map(item => {
      return {
        value: item.plannedLoadingWeek,
        label:  `${item.plannedLoadingWeek}/${new Date(item.plannedLoadingDate).getFullYear()}`
      }
    })
    const removeDuplicates = (array) => {
      const uniqueArray = array.filter((obj, index, self) =>
        index === self.findIndex((o) => o.value === obj.value)
      );
      return uniqueArray;
    };
    const uniqueWeek = removeDuplicates(list);
    setLoadingWeekOptions(uniqueWeek)
  }

  const getLacquaredRangeList = async () => {
    const list = await OAuthService.getList(
      lacquaredUrl + `/search/findLacqueredActiveRanges`
    );
    const productIds = list?.data?._embedded?.ranges.map((item) => item.productId)
    setLacqueredRanges(productIds)
  }
  useEffect(() => {
    getLacquaredRangeList();
  }, [])

  useEffect(() => {
    // getStatusList();
    getFilterLoadingWeekList()
  }, [containerPlanList])
  const getCityList = async () => {
    const targetCustomer = customer.find(item => item.id === filter.companyId);
    const list = await OAuthService.getList(
      portsUrl + `?sort=portCode,asc&size=1000`
    );
    const ports = list.data?._embedded?.ports;
    if (targetCustomer) {
      const countryPorts = ports.filter((p) =>
        p.countryName.includes(targetCustomer.countryName)
      );
      const portsData = countryPorts.map((port) => {
        return {
          value: port.portCode,
          label: port?.displayName.toUpperCase(),
        };
      });
      setRegionOptions(portsData);
      setDestinationOptions([{ value: "all", label: "All Destination" }, ...portsData])
    } else {
      const portsData = ports.map((port) => {
        return {
          value: port.portCode,
          label: port?.displayName.toUpperCase(),
        };
      });
      setRegionOptions(portsData);
      setDestinationOptions([{ value: "all", label: "All Destination" }, ...portsData])

    }


  };
  const getInitialCityList = async () => {
    if (token) {
      const targetCustomer = customer.find(item => item.id === token.company);
      const list = await OAuthService.getList(
        portsUrl + `?sort=portCode,asc&size=1000`
      );
      const ports = list.data?._embedded?.ports;
      // const countryPorts = ports.filter((p) =>
      //   p.countryName.includes(targetCustomer.countryName)
      // );
      if (hasPartnerAdminRole && targetCustomer) {
        const countryPorts = ports?.filter((p) =>
          p.countryName.includes(targetCustomer.countryName)
        );
        const portsData = countryPorts?.map((port) => {
          return {
            value: port.portCode,
            label: port?.displayName.toUpperCase(),
          };
        });
        setRegionOptions(portsData);
        setDestinationOptions([{ value: "all", label: "All Destination" }, ...portsData])
      } else {
        const portsData = ports.map((port) => {
          return {
            value: port.portCode,
            label: port?.displayName.toUpperCase(),
          };
        });
        setRegionOptions(portsData);
        setDestinationOptions([{ value: "all", label: "All Destination" }, ...portsData])
      }

    }
  };
  const getISOWeek = (date) => {
    const tmpDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = tmpDate.getUTCDay() || 7;
    tmpDate.setUTCDate(tmpDate.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(tmpDate.getUTCFullYear(), 0, 1));
    return Math.ceil((((tmpDate - yearStart) / 86400000) + 1) / 7);
  };

  const getWeeksInYear = (year) => {
    const dec31 = new Date(year, 11, 31);
    const week = getISOWeek(dec31);
    return week === 1 ? 52 : week;
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();

    const years = [
      { label: `${currentYear - 1}`, value: currentYear - 1 },
      { label: `${currentYear}`, value: currentYear },
      { label: `${currentYear + 1}`, value: currentYear + 1 }
    ];
    setYearOptions(years);

    const weeksInYear = getWeeksInYear(currentYear);
    const weekList = Array.from({ length: weeksInYear }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }));
    setWeekOptions(weekList);

    // setSelectedYear(currentYear);
    setFilter((prev) => ({
      ...prev,
      year: null,
      loadingWeek: null
    }));
    setCurrentPage(1);
    setFilterPagination((prev) => ({
      ...prev,
      year: null,
      loadingWeek: null,
      pageNo: 0,
    }));
  }, []);
  useEffect(() => {
    if (selectedYear) {
      const updatedFilter = { ...filter, fromDate: null, toDate: null };
      setFilter(updatedFilter);
      setCurrentPage(1);
      setFilterPagination((prev) => ({ ...prev, fromDate: null, toDate: null, pageNo: 0 }));
    }
  }, [selectedYear])
  useEffect(() => {
    if (!isOpen) {
      const updatedFilter = { ...filter, pageSize: 24 };
      setFilter(updatedFilter);
      setCurrentPage(1);
      setFilterPagination((prev) => ({ ...filter, pageSize: 24, pageNo: 0 }));
    } else {
      const updatedFilter = { ...filter, pageSize: 10 };
      setFilter(updatedFilter);
      setCurrentPage(1);
      setFilterPagination((prev) => ({ ...filter, pageSize: 10, pageNo: 0 }));
    }
  }, [isOpen])

  const handleYearChange = (e) => {
    // If cleared
    if (!e) {
      setSelectedYear(null);
      setSelectedWeek(selectedWeek ? selectedWeek : null);
      setFilter((prev) => ({
        ...prev,
        loadingWeek: selectedWeek ? selectedWeek : null,
        year: null,
      }));
      setCurrentPage(1);
      setFilterPagination((prev) => ({
        ...prev,
        loadingWeek: selectedWeek ? selectedWeek : null,
        year: null,
        pageNo: 0,
      }));
      setWeekOptions([]);
      return;
    }

    // If a year is selected
    setSelectedYear(e.value);
    setSelectedWeek(selectedWeek ? selectedWeek : null);
    setFilter((prev) => ({
      ...prev,
      loadingWeek: selectedWeek ? selectedWeek : null,
      year: e.value,
    }));
    setCurrentPage(1);
    setFilterPagination((prev) => ({
      ...prev,
      loadingWeek: selectedWeek ? selectedWeek : null,
      year: e.value,
      pageNo: 0,
    }));

    const weeksInYear = getWeeksInYear(e.value);
    const weekList = Array.from({ length: weeksInYear }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1,
    }));
    setWeekOptions(weekList);
  };
  //   const handleYearChange = (e) => {
  //   setSelectedYear(e.value);
  //   setSelectedWeek(null);
  //   setFilter((prev) => ({
  //     ...prev,
  //     loadingWeek: null,
  //     year: e.value
  //   }));
  //   setCurrentPage(1);
  //   setFilterPagination((prev) => ({
  //     ...prev,
  //     loadingWeek: null,
  //     year: e.value,
  //     pageNo: 0,
  //   }));

  //   const weeksInYear = getWeeksInYear(e.value);
  //   const weekList = Array.from({ length: weeksInYear }, (_, i) => ({
  //     label: `${i + 1}`,
  //     value: i + 1
  //   }));
  //   setWeekOptions(weekList);
  // };

  const handleWeekChange = (e) => {
    setSelectedWeek(e?.value || null);
    setFilter((prev) => ({
      ...prev,
      loadingWeek: e?.value || null,
      year: selectedYear
    }));
    setCurrentPage(1);
    setFilterPagination((prev) => ({
      ...prev,
      loadingWeek: e?.value || null,
      year: selectedYear,
      pageNo: 0,
    }));
  };
  const getCustomerList = async () => {
    if (hasIAMRole) {
      const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${token.email}`;
      const areaManager = await OAuthService.getList(findAllByAreaManagerUrl);
      const areaManagerIds =
        areaManager?.data?._embedded?.territories?.map((t) => t.id) || [];
      const queryParams = areaManagerIds
        .map((id) => `territories=${id}`)
        .join("&");

      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryIn?${queryParams}`;
      const partners = await OAuthService.getList(url);
      const companies = partners.data?._embedded?.companies;
      const companiesData = companies.map((item) => {
        return {
          value: item.id,
          label: `${item.id}-${item.shortKey}-${item.countryName}`,
        };
      });
      setSelectedCustomer({
        value: "all",
        label: `All`,
      });
      setCustomer(companies);
      setCompaniesOptions([{ value: "all", label: "All" }, ...companiesData]);
    } else {
      const list = await OAuthService.getList(
        companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`
      );
      const companies = list.data?._embedded?.companies;
      const companiesData = companies.map((item) => {
        return {
          value: item.id,
          label: `${item.id}-${item.shortKey}-${item.countryName}`,
        };
      });
      if (hasSuperRole || hasMDRole || hasLogisticsRole) {
        setSelectedCustomer({
          value: "all",
          label: `All`,
        });
      } else {
        const defaultCustomer = companies.find(
          (item) => item.id === token.company
        );
        setSelectedCustomer({
          value: defaultCustomer.id,
          label: `${defaultCustomer.id}-${defaultCustomer.shortKey}-${defaultCustomer.countryName}`,
        });
      }
      setCustomer(companies);
      setCompaniesOptions([{ value: "all", label: "All" }, ...companiesData]);
    }
  };
  const [gridParams, setGridParams] = useState(null);


  const onBtExport = useCallback(() => {
    const params = {
      fileName: "PendingOrder.xlsx",
      sheetName: "Pending Order",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const getAutoWidths = (sheetRows) => {
    const colWidths = [];
    sheetRows.forEach((row) => {
      row.forEach((cell, i) => {
        const val = typeof cell === "object" ? cell?.v || "" : cell;
        const len = val.toString().length;
        colWidths[i] = Math.max(colWidths[i] || 10, len + 2);
      });
    });
    return colWidths.map((w) => ({ wch: w }));
  };

const getSmartBorder = (rowIdx, colIdx, startRow, endRow, colCount) => ({
  top: { style: rowIdx === startRow ? "medium" : "thin", color: { rgb: "000000" } },
  bottom: { style: rowIdx === endRow ? "medium" : "thin", color: { rgb: "000000" } },
  left: { style: colIdx === 0 ? "medium" : "thin", color: { rgb: "000000" } },
  right: { style: colIdx === colCount - 1 ? "medium" : "thin", color: { rgb: "000000" } }
});
const handleOpenTableView = () => {
  const tableViewFilter = {
    ...filter,
    pageSize: 50,
    pageNo:0,
  };

  sessionStorage.setItem(
    "tableAnalysisFilter",
    JSON.stringify(tableViewFilter)
  );

  navigate("/table-analysis");
};
useEffect(() => {
   const updatedFilter={
    ...filter,
    pageNo:0,
    pageSize: 50,
  };

  sessionStorage.setItem(
    "tableAnalysisFilter",
    JSON.stringify(updatedFilter)
  );
  sessionStorage.setItem(
    "orderFilter",
    JSON.stringify(filter)
  );
}, [filter]);
const exportBookingExcel = (selectedContainerIds) => {
  const sheetRows = [];

    selectedContainerIds.forEach((container) => {
      const blockStartRow = sheetRows.length + 2;
      const block = [];

      block.push([], []);

      block.push([
        { v: `CONTAINER - ${container.containerNo}`, s: {} },
        { v: `Port: ${container.destination}`, s: {} },
        { v: `Week: ${container.plannedLoadingWeek}`, s: {} },
        { v: "", s: {} },
        { v: `Container Type: ${container.containerType}`, s: {} }
      ]);

      const headerRow = ["Sl. No.", "AB Number", "Commission Name", "Volume", "Product"];
      block.push(headerRow.map((text) => ({ v: text, s: {} })));

      let totalVolume = 0;
      container.orders.forEach((order, index) => {
        totalVolume += order.volume || 0;
        block.push([
          { v: index + 1, s: {} },
          { v: order.abNumber || "", s: {} },
          { v: order.commissionName || "", s: {} },
          { v: order.volume || 0, s: {} },
          { v: order.product || "", s: {} }
        ]);
      });

      block.push([
        { v: "", s: {} },
        { v: "", s: {} },
        { v: "Total Volume", s: {} },
        { v: totalVolume.toFixed(3), s: {} },
        { v: "", s: {} }
      ]);

      block.push([
        { v: `Forwarder: ${container.forwarderName || ""}`, s: {} },
        { v: "", s: {} },
        { v: `Email: ${container.forwarderEmail || ""}`, s: {} },
        { v: "", s: {} },
        { v: `Contact: ${container.forwarderNumber || ""}`, s: {} }
      ]);

      const colCount = 5;
      const blockEndRow = blockStartRow + block.length - 1;
      for (let r = 2; r < block.length; r++) {
        for (let c = 0; c < colCount; c++) {
          const cell = block[r][c];
          if (cell) {
            cell.s = {
              font: r === 2 || r === block.length - 1 ? { bold: true, color: { rgb: "000000" } } : {},
              fill: r === 2 ? { fgColor: { rgb: "FF9900" } } : r === 3 || r === block.length - 1 ? { fgColor: { rgb: "CCFFCC" } } : undefined,
              border: getSmartBorder(blockStartRow + r, c, blockStartRow + 2, blockEndRow, colCount)
            };
          }
        }
      }

      sheetRows.push(...block);
    });

    const worksheet = utils.aoa_to_sheet(sheetRows);
    worksheet["!cols"] = getAutoWidths(sheetRows);

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Booking Info");

    writeFile(workbook, `BookingRequest_${new Date().toISOString().slice(0, 10)}.xlsx`);
    setSelectedContainerIds([]);
  };

  const orderHeaderAction = () => {
    const fileInputRef = useRef(null);

    const nosVendor = {};
    const ekVendor = {};
    loadingWeekData.forEach((item) => {
      const nosCategory = item.kitchenName.includes("Non Lacquered") ? "Non Lacquered" : "Lacquered";
      const ekCategory = item.kitchenName.includes("Normal Handle") ? "Normal Handle" : "SystemLine";

      const subcategory = item.kitchenName.includes("Nolte Kitchen")
        ? "NK"
        : item.kitchenName.includes("Nolte Neo")
          ? "NN"
          : item.kitchenName.includes("Nolte Eco")
            ? "NE"
            : item.kitchenName.includes("Nolte Spa")
              ? "NS"
              : "EK";

      if (!nosVendor[nosCategory]) {
        nosVendor[nosCategory] = {};
      }

      if (!ekVendor[ekCategory]) {
        ekVendor[ekCategory] = {};
      }

      if (!nosVendor[nosCategory][subcategory]) {
        nosVendor[nosCategory][subcategory] = {
          week: item.week,
          year: item.year,
        };
      }
      if (!ekVendor[ekCategory][subcategory]) {
        ekVendor[ekCategory][subcategory] = {
          week: item.week,
          year: item.year,
        };
      }
    });
    const nosCategories = Object.keys(nosVendor);
    const ekCategories = Object.keys(ekVendor);
    const tableTextColor =  "#fff" ;

    return (
      <Box className="flex flex-col gap-3">
        {/* ================= ROW 1 ================= */}
        <Box
          className="flex  gap-2 mb-4"
          sx={{
            flexWrap: "wrap",
            "& .MuiTableCell-root": {
              padding: "4px 6px",
              lineHeight: "normal",
            },
          }}
        >
          {/* Export */}
          {!(hasLogisticsRole|| isMobile) && (
            <div className={`flex items-center ${isMobile ? "" : "mr-24"}`}>
              <Tooltip title="Export">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onBtExport}
                >
                  <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
                </Button>
              </Tooltip>
            </div>
          )}
          {!isMobile && (
            <>
              {/* Current Loading Week Label */}
              <Box className="flex items-center " sx={{ mr: 2 }}>
                Current <br /> Loading <br /> Week
              </Box>

              {/* NK / NN / NE / NS table */}
              <TableContainer
                sx={{
                  width: 320,
                  mr: 2,
                  background: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                }}
                component={Paper}
              >
                <Table
                  size="small"
                  sx={{
                    "& .MuiTableCell-root": {
                      color: tableTextColor,
                      borderColor: theme.palette.divider,
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      {["NK", "NN", "NE", "NS"].map((subcategory) => (
                        <TableCell key={subcategory} className="text-11">
                          {subcategory}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {nosCategories.map((category) => (
                      <TableRow
                        key={category}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell className="text-11">
                          {category === "Non Lacquered"
                            ? "Non Lacquered"
                            : "Lacquered"}
                        </TableCell>
                        {["NK", "NN", "NE", "NS"].map((subcategory) => (
                          <TableCell
                            key={`${category}-${subcategory}`}
                            className="text-11"
                          >
                            {nosVendor[category][subcategory]
                              ? nosVendor[category][subcategory].week
                              : 0}
                            /
                            {nosVendor[category][subcategory]
                              ? nosVendor[category][subcategory].year
                              : ""}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* EK table */}
              <TableContainer
                sx={{
                  width: 150,
                  mr: 2,
                  background: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                }}
                component={Paper}
              >
                <Table
                  size="small"
                  sx={{
                    "& .MuiTableCell-root": {
                      color: tableTextColor,
                      borderColor: theme.palette.divider,
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      {["EK"].map((subcategory) => (
                        <TableCell key={subcategory} className="text-11">
                          {subcategory}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ekCategories.map((category) => (
                      <TableRow
                        key={category}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell className="text-11">
                          {category === "Normal Handle"
                            ? "Normal Handle"
                            : "SystemLine"}
                        </TableCell>
                        {["EK"].map((subcategory) => (
                          <TableCell
                            key={`${category}-${subcategory}`}
                            className="text-11"
                          >
                            {ekVendor[category][subcategory]
                              ? ekVendor[category][subcategory].week
                              : 0}
                            /
                            {ekVendor[category][subcategory]
                              ? ekVendor[category][subcategory].year
                              : ""}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
          {/* Customer Filter */}
          {(hasSuperRole || hasLogisticsRole || hasIAMRole) && (
            <div className="flex items-center justify-center">
              <Select
                name="companyId"
                value={
                  filter.companyId &&
                  companiesOptions?.filter(
                    (obj) => filter.companyId === obj.value,
                  )
                }
                onChange={(e) => handleSelectChange(e, "companyId")}
                placeholder="Customer"
                options={companiesOptions}
                styles={customStyles()}
                className="w-[200px]"
              />
            </div>
          )}
          {hasLogisticsRole && (
            <div className="flex items-center justify-center ml-2">
              <Tooltip title="Export Container Information">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    exportBookingExcel(getFreshSelectedContainers())
                  }
                  disabled={selectedContainerIds.length > 0 ? false : true}
                >
                  <FuseSvgIcon>heroicons-solid:save</FuseSvgIcon>
                </Button>
              </Tooltip>
            </div>
          )}

          {/* Add Container */}
        </Box>

        {/* ================= ROW 2 ================= */}
       <Box className="flex gap-2 items-center justify-between" sx={{ flexWrap: "wrap" }}>
          {(hasSuperRole ||
            hasIAMRole ||
            hasLogisticsRole ||
            hasPartnerAdminRole) && (
            <Tooltip title={"Goto Table View"}>
              <Button
                onClick={handleOpenTableView}
                color="primary"
                variant="contained"
              >
                <FuseSvgIcon size={24}>material-outline:view_list</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}
          {hasSuperRole && !isMobile  && (
            <Tooltip title={isOpen ? "Hide Orders" : "Show Orders"}>
              <Button
                onClick={() => setIsOpen(!isOpen)}
                color="secondary"
                variant="contained"
              >
                {isOpen ? <HorizontalSplitIcon /> : <VerticalSplitIcon />}
              </Button>
            </Tooltip>
          )}
          {hasSuperRole && !isMobile && (
            <Tooltip title="Create Containers from Excel">
              <Button
                variant="contained"
                color="secondary"
                disabled={loadingExcel}
                onClick={() => fileInputRef.current?.click()}
                sx={{
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.secondary.contrastText,
                  "&:hover": {
                    backgroundColor: theme.palette.secondary.dark,
                  },
                }}
              >
                <FuseSvgIcon size={16} sx={{ display: "inline-block", mr: 1 }}>
                  heroicons-outline:upload
                </FuseSvgIcon>
                {loadingExcel ? "Reading..." : "Upload"}
                {loadingExcel && <CircularProgress size={20} sx={{ ml: 1 }} />}
                <input
                  ref={fileInputRef}
                  type="file"
                  hidden
                  accept=".xlsx,.xlsm"
                  onChange={handleExcelUploadToCreateContainers}
                />
              </Button>
            </Tooltip>
          )}

          {hasEditRole && (
            <Tooltip title="Add Container">
              <Button
                onClick={handleAddContainer}
                color="secondary"
                variant="contained"
                startIcon={<FuseSvgIcon>heroicons-solid:plus</FuseSvgIcon>}
                disabled={
                  hasPartnerAdminRole
                    ? false
                    : selectedCompanyId === "all" || !selectedCompanyId
                    ? true
                    : false
                }
              >
                Container
              </Button>
            </Tooltip>
          )}

          {/* Export Container Info */}
          {(hasSuperRole || hasPartnerAdminRole) && (
            <Tooltip title="Export Container Information">
              <Button
                variant="contained"
                color="secondary"
                startIcon={
                  <FuseSvgIcon sx={{ display: "inline-block", mr: 1 }}>
                    heroicons-solid:save
                  </FuseSvgIcon>
                }
                onClick={() => exportBookingExcel(getFreshSelectedContainers())}
                disabled={selectedContainerIds.length > 0 ? false : true}
              >
                Containers
              </Button>
            </Tooltip>
          )}
          {/* Partner Admin */}
          {hasPartnerAdminRole && (
            <>
              <Button
                color="secondary"
                variant="contained"
                onClick={() =>
                  handleBookingToFactory(
                    "bookingToNfze",
                    "Send Booking Request",
                    bookingEmailContentNfze(),
                  )
                }
                disabled={
                  selectedContainerIds.length === 0 ||
                  selectedContainerIds.some((c) => c.status === "OPEN")
                }
              >
                Booking request to NFZE
              </Button>

              <Tooltip title="Add Forwarder Info">
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => setOpenForwarderInfo(true)}
                  startIcon={<GroupAddIcon />}
                  disabled={
                    selectedContainerIds.length === 0 ||
                    !selectedContainerIds.every((c) => c.status === "OPEN")
                  }
                >
                  Forwarder Info
                </Button>
              </Tooltip>
            </>
          )}

          {/* Super Role */}
          {hasSuperRole && (
            <>
              <Button
                id="booking-button"
                aria-controls={openBooking ? "booking-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openBooking ? "true" : undefined}
                onClick={handleBookingClick}
                color="secondary"
                variant="contained"
                endIcon={<KeyboardArrowDownIcon />}
                disabled={
                  selectedContainerIds.length === 0 ||
                  selectedContainerIds.some(
                    (container) => container.status === "OPEN",
                  )
                }
              >
                Booking
              </Button>

              <StyledMenu
                id="booking-menu"
                anchorEl={anchorE2}
                open={openBooking}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "booking-button",
                }}
              >
                <MenuItem
                  onClick={() =>
                    handleBookingToFactory(
                      "bookingToFactory",
                      "Send Booking Request",
                      bookingEmailContentFactory(),
                    )
                  }
                >
                  Booking request to factory
                </MenuItem>
                {!hasSuperRole && (
                  <MenuItem
                    onClick={() =>
                      handleBookingToFactory(
                        "bookingToNfze",
                        "Send Booking Request",
                        bookingEmailContentNfze(),
                      )
                    }
                  >
                    Booking request to NFZE
                  </MenuItem>
                )}

                <MenuItem
                  onClick={() =>
                    handleBookingToFactory(
                      "bookingRequestRelease",
                      "Release Request",
                      releaseRequestEmailContent(),
                    )
                  }
                >
                  Release request
                </MenuItem>
              </StyledMenu>

              <Tooltip title="Add Forwarder Info">
                <Button
                  color="secondary"
                  variant="contained"
                  startIcon={<GroupAddIcon />}
                  onClick={() => setOpenForwarderInfo(true)}
                  disabled={!selectedContainerIds.length}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 160,
                  }}
                >
                  Forwarder Info
                </Button>
              </Tooltip>

              <Tooltip title="Clean to issue PI">
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={handleReadyIssuePI}
                  disabled={selectedContainerIds.length > 0 ? false : true}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 160,
                  }}
                >
                  Ready to PI
                </Button>
              </Tooltip>

              <Tooltip title="Revert PI">
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={handleRevertPI}
                  startIcon={<SettingsBackupRestoreIcon />}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 160,
                  }}
                  disabled={
                    selectedContainerIds.length > 0 &&
                    selectedContainerIds.every(
                      (container) => container.proformaStatus === "READY_TO_PI",
                    )
                      ? false
                      : true
                  }
                >
                  Revert PI
                </Button>
              </Tooltip>
            </>
          )}
        </Box>
      </Box>
    );
  };

  const handleViewContainer = (item) => {
    setSelectedContainer(item);
    setOpenViewContainer(true);
  };

  const handleEditContainer = (item) => {
    setSelectedContainer(item);
    setOpenEditContainer(true);
  };

  const handlePurge = async (item) => {
    try {
      await OAuthService.deleteData(url, item.id);
      setSuccessMsg("Container deleted Successfully");
      setSnackState(true);
      getContainerPlans();
      getOrderList();
    } catch (error) {
      // console.log("error", error);
      // setError(error.message);
      toast.error(error?.response?.data?.errorMessage || error.message)
    }
  };

  const handleSubmit = async (data) => {
    setCheckSubmit(true);
    const selectedContainerType = containerType.filter(
      (obj) => obj.containerId === data.containerType.value
    );
    // console.log('data.cutOffDate', data.cutOffDate)
    const date = data.cutOffDate
    const cutOffDate = moment(date).format('YYYY-MM-DD');
    // console.log('cutOffDate', cutOffDate)
    const payload = {
      containerStatus: data.status.value,
      companyId: hasSuperRole ? filter.companyId : selectedCustomer.value,
      status: data.status.value,
      // actualLoadingDate: data.loadingWeek.id,
      // actualLoadingWeek: data.loadingWeek.value,
      // loadingWeek: data.loadingWeek.value,
      plannedLoadingWeek: data.loadingWeek.value,
      plannedLoadingYear: data.loadingWeek.year,
      // containerNo: generateId,
      actualContainerType: selectedContainerType[0],
      // plannedContainerType: selectedContainerType[0],
      destination: data.destination.label,
      forwarderInfo: {
        name: data.forwarderName,
        contact: data.forwarderNumber,
        emailAddress: data.forwarderEmail,
      },
      cutOffDate: data.cutOffDate,
      comment: data.comment,
      orderIds: [],
      shippingType: selectedContainerType[0].modeOfShipment,
    };
    await OAuthService.addData(getContainersUrl, payload);
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
    setOpenDialog(false);
    getContainerPlans();
  };

  const checkLoadingWeeks = (orders, container) => {

    const containerCompanyId = container?.companyId || null;
    const containerLoadingWeek = container?.plannedLoadingWeek ?? null;
    const combinedOrders = [...(container?.orders || []), ...orders];
    const hasEK = combinedOrders.some(item => item.vendorShortKey === "EK");
    const hasNonEK = combinedOrders.some(item => item.vendorShortKey !== "EK");
    const isMixed = hasEK && hasNonEK;


    const loadingWeeks = orders.map(order => order?.plannedLoadingWeek);
    const customerNums = orders.map(order => order?.customerNum);
    const countries = orders.map(order => order?.country);

    const isValid = (
      loadingWeeks.length > 0 &&
      loadingWeeks.every(v => v != null && v !== 0) &&
      new Set(loadingWeeks).size === 1
    );

    setIsValidLoadingWeeks(isValid);
    setUniqueLoadingYear(new Date(orders[0]?.plannedLoadingDate).getFullYear());

    const uniqueCustomers = [...new Set(customerNums)];
    const uniqueCustomer = uniqueCustomers.length === 1;

    const cleanedWeeks = loadingWeeks.filter(v => v != null);
    const uniqueNonZero = [...new Set(cleanedWeeks.filter(v => v !== 0))];

    if (isValid) {
      setUniqueLoadingWeek(uniqueNonZero[0]);
    }

    const uniqueWeeks = uniqueNonZero.length <= 1;
    const allFromIndia = countries.every(country => country === "India");

    if (!allFromIndia) {
      if (!uniqueCustomer) return { isValid: false, isMixed };
      if (containerCompanyId !== null && containerCompanyId !== uniqueCustomers[0]) {
        return { isValid: false, isMixed };
      }
    }

    if (
      containerLoadingWeek !== null &&
      uniqueNonZero.length === 1 &&
      uniqueNonZero[0] !== containerLoadingWeek
    ) {
      return { isValid: false, isMixed };
    }

    return { isValid: uniqueWeeks, isMixed };
  };
  useEffect(() => {
    if (!gridParams) return;

    const cleanupDropZones = () => {
      dropZoneRefs.current.forEach((dropZone, key) => {
        try {
          gridParams.removeRowDropZone(dropZone);
        } catch (err) {
          console.warn(`Failed to remove drop zone for ${key}:`, err);
        }
      });
      dropZoneRefs.current.clear();
    };

    const setupDropZones = () => {
      containerPlanList.forEach((container) => {
        const containerElement = document.getElementById(container.id);
        if (containerElement) {
          const dropZone = {
            getContainer: () => containerElement,
            onDragEnter: () => {
              setActiveContainer(container.id);
            },
            onDragStop: async (params) => {
              await handleDragStop(params, container);
            },
          };
          gridParams.addRowDropZone(dropZone);
          dropZoneRefs.current.set(container.id, dropZone);
        } else {
          console.warn(`Container with ID ${container.id} not found.`);
        }
      });

      const emptyContainer = document.getElementById("emptyContainer");
      if (emptyContainer) {
        const dropZone = {
          getContainer: () => emptyContainer,
          onDragEnter: () => {
            setActiveContainer("emptyContainer");
          },
          onDragStop: async (params) => {
            await handleEmptyContainerDragStop(params);
          },
        };
        gridParams.addRowDropZone(dropZone);
        dropZoneRefs.current.set("emptyContainer", dropZone);
      }
    };
    const handleDragStop = async (params, container) => {
      if (container?.containerStatus !== "OPEN" && hasPartnersRole) {
        setOpenWarningAlertContainerStatus(true);
        setActiveContainer(null);
        return;
      }

      const nodes = params.nodes;
      const draggedNode = nodes.map((node) => node.data);
      let totalOrderVolume = 0;

      const { isValid, isMixed } = checkLoadingWeeks(draggedNode, container);

      if (isValid) {
        const maxVolume =
          isMixed
            ? container?.actualContainerType?.mixedMaxVolume
            : container?.actualContainerType?.maxVolume || 61.2;


        const previousOrders = [...container.orders];
        const combinedOrders = [...previousOrders, ...draggedNode];
        const updatedOrders = [];

        for (const item of combinedOrders) {
          if (totalOrderVolume + Number(item.volume) <= maxVolume) {
            updatedOrders.push(item);
            totalOrderVolume += Number(item.volume);
          } else {
            setOpenWarningAlertVolume(true);
            return;
          }
        }

        const containerClone = { ...container, orders: updatedOrders };

        setPendingOrderChanges({
          containerId: container.id,
          previousOrders,
        });

        setSelectedContainer(containerClone);
        setOpenEditContainer(true);
        setTotalVolume(totalOrderVolume);

        gridRef.current.api.applyTransaction({
          remove: draggedNode,
        });

        setActiveContainer(null);
      } else {
        setOpenWarningAlert(true);
        setActiveContainer(null);
      }
    };
    const handleEmptyContainerDragStop = async (params) => {
      const nodes = params.nodes;
      const draggedNode = nodes.map((node) => node.data);
      let totalOrderVolume = 0;

      const { isValid, isMixed } = checkLoadingWeeks(draggedNode, null);

      if (isValid) {
        draggedNode.forEach((item) => {
          totalOrderVolume += Number(item.volume);
        });

        setTotalVolume(totalOrderVolume);
        await addNewContainer(draggedNode, true);

        setActiveContainer(null);
        gridRef.current.api.applyTransaction({
          remove: nodes.map((node) => node.data),
        });
      } else {
        setOpenWarningAlert(true);
        setActiveContainer(null);
      }
    };


    cleanupDropZones();
    setupDropZones();

    return () => {
      cleanupDropZones();
    };
  }, [gridParams, containerPlanList, selectedCompanyId]);




  const addNewContainer = async (nodeData, previousNode = []) => {

    setNewOrder(nodeData);
    setOpenContainerForm(true);
    const newOrderVolume = nodeData.reduce((a, b) => a + Number(b.volume), 0);
    let filteredContainerType = [];

    if (newOrderVolume <= 25.2) {
      filteredContainerType = defContainerTypeOptions;
      setContainerTypeOptions(filteredContainerType);
      return;
    }

    if (newOrderVolume < 50.2) {
      filteredContainerType = defContainerTypeOptions.filter(
        (item) =>
          item.label === `40' HC` ||
          item.label === `40' DV` ||
          item.label === "TRUCK"
      );

      setContainerTypeOptions(filteredContainerType);
      return;
    }

    filteredContainerType = defContainerTypeOptions.filter(
      (item) => item.label === `40' HC` || item.label === "TRUCK"
    );
    setContainerTypeOptions(filteredContainerType);
    return;
  };
  const [formDataList, setFormDataList] = useState([]);
  const handleNewContainer = async (formData, activeStep, orders, cutOffDate) => {
    //  console.log('formData', formData)
    const result = [];
    const stepDataLength = orders.length;
    // console.log('stepDataLength', stepDataLength)
    for (let i = 1; i <= stepDataLength; i++) {
      const order = {};
      const stepProperties = Object.keys(formData).filter((key) =>
        key.includes(`${i}`)
      );

      for (const prop of stepProperties) {
        const propWithoutNumber = prop.replace(/\d+$/, "");
        const propValue = formData[prop];
        if (
          propWithoutNumber === "name" ||
          propWithoutNumber === "contact" ||
          propWithoutNumber === "emailAddress"
        ) {
          order.forwarderInfo = order.forwarderInfo || {};
          order.forwarderInfo[propWithoutNumber] = propValue;
        } else if (propWithoutNumber === "loadingWeek") {
          // order.actualLoadingDate = propValue.id;
          order.plannedLoadingYear = propValue.year;
          order.plannedLoadingWeek = propValue.value;
        } else if (propWithoutNumber === "containerType") {
          const containerTypeId = propValue.value;
          const selectedContainerType = containerType.filter(
            (obj) => obj.containerId === containerTypeId
          );
          order.actualContainerType = selectedContainerType[0];
          order.shippingType = selectedContainerType[0].modeOfShipment;
          // order.plannedContainerType = selectedContainerType[0];
        } else if (typeof propValue === "object" && "label" in propValue) {
          order[propWithoutNumber] = propValue.label;
        } else {
          order[propWithoutNumber] = propValue;
        }
      }
      order.companyId = hasSuperRole && selectedCustomer.value === "all" || "" ? orders[0][0].customerNum : selectedCustomer.value;
      order.containerStatus = "OPEN";
      order.status = "OPEN";
      // order.orders = orders[i - 1];
      order.orderIds = orders[i - 1].map(item => item.id);
      order.cutOffDate = moment(cutOffDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
      if (i > 1) {
        const prevStepData = result[i - 2];
        for (const prop in prevStepData) {
          if (order[prop] === undefined) {
            order[prop] = prevStepData[prop];
          }
        }
      }
      try {
        await OAuthService.addData(getContainersUrl, order);
        result.push(order);
        getContainerPlans();
        getOrderList();
        setActiveStep(0);
        setFormData({})
      } catch (error) {
        // setError(error.errorMessage||error.message);
        toast.error(error?.response?.data?.errorMessage || error.message)
        setActiveStep(0);
        setFormData({})
      }
    }

    // getContainerPlans();
  };

  const handleEditSubmit = async (data) => {
    const findContainerType = containerType.filter(
      (item) => item.containerId === data.containerType.value
    );
    const orderId = selectedContainer.orders.map(item => item.id)
    const { orders, id, version, ...modifiedContainer } = selectedContainer;
    const payload = {
      ...modifiedContainer,
      containerStatus: data.containerStatus.value,
      status: data.containerStatus.value,
      actualContainerType: findContainerType[0],
      plannedLoadingWeek: data.loadingWeek.value,
      plannedLoadingYear: data.loadingWeek.year,
      destination: data.destination.label,
      forwarderInfo: {
        name: data.forwarderName,
        contact: data.forwarderNumber,
        emailAddress: data.forwarderEmail,
      },
      comment: data.comment,
      cutOffDate: moment(data?.cutOffDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      orderIds: orderId,
      totalVolume: selectedContainer.orders.reduce((a, b) => a + b.volume, 0),
      shippingType: "",
    };
    if (data?.actualContainerNo2) {
      payload.actualContainerNumber = data.actualContainerNo2;
    }

    if (data?.actualLoadingDate2) {
      payload.actualLoadingDate = data.actualLoadingDate2;
    }

    if (data?.tourNo2) {
      payload.tourNo = data.tourNo2;
    }
    try {
      await OAuthService.updateData(getContainersUrl, selectedContainer?.id, payload);
      setSuccessMsg("Data Updated Successfully");
      setSnackState(true);
      setOpenEditContainer(false);
      getContainerPlans();
      getOrderList();
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
      // console.log(error.message);
      // setError(error.message);
    }
  };

  const getCustomerOrders = async () => {
    gridParams?.showLoadingOverlay();
    let list = '';
    try {
      if (filter?.companyId !== "all" && filter?.companyId) {
        list = await OAuthService.getList(
          containerOrdersUrl + `?customerNum=${filter?.companyId}&sort=desc`
        );
      } else {
        list = await OAuthService.getList(containerOrdersUrl);
      }
      const orders = list?.data;
      setRowData(orders);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
    }finally {
    gridParams?.hideOverlay();
  }
  };

  useEffect(() => {
    // getContainerTypeList();
    getCustomerList();
    getLoadingWeekList();
    // getContainerId();
  }, []);
  useEffect(() => {
    if(gridParams){
     getOrderList();

   }
  }, [gridParams])
  

  useEffect(() => {
    getContainerTypeList();
  }, [openContainerForm]);

  useEffect(() => {
    getContainerPlans(filterPagination);
  }, [filterPagination]);

  useEffect(() => {
    if (filter && filter.companyId && !hasLogisticsRole) {
      if(gridParams){

        getCustomerOrders()
      }
    }
  }, [filter,gridParams])

  // useEffect(() => {
  //   addDropZones();
  // }, [containerPlanList]);

  useEffect(() => {
    getInitialCityList()
  }, [customer]);

  useEffect(() => {
    if (filter && filter?.companyId) {
      getCityList();
    }
  }, [filter,customer]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const onRowDoubleClicked = (params) => {
    const id = params.data?.id;
    if (hasPartnerAdminRole && id) {
      if (token?.company === params?.data?.customerNum) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerOrderProRole && id) {
      if (token?.email === params?.data?.createdByUser) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerShwMngrRole && id) {
      if (hasShowroom(token?.showroom, params?.data?.showroomNum)) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasSuperRole && id) {
      window.open(`/order/order-details/${id}`, '_blank');
    }
  };

  const selectedOrderVol = () => {
    let totalVolume = 0;
    for (const obj of selectedRows) {
      if (obj.hasOwnProperty("volume")) {
        totalVolume += Number(obj["volume"]);
      }
    }
    return totalVolume.toFixed(3);
  };

  const selectedLoadingWeek = [
    ...new Set(selectedRows.map((order) => order.loadingWeek)),
  ];



  const handleSelectDestinationChange = (data, key, action = {}) => {
    let value = [];
    if (action.action !== "clear" && Array.isArray(data)) {
      value = data.map((item) => item.label);
    }
    if (value.includes("All Destination")) {
      value = [];
    }

    const updatedFilter = { ...filter, [key]: value };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, [key]: value, pageNo: 0 }));

  };

  const handleSelectChange = (data, key, action = {}) => {

    const value = action.action === "clear" ? "" : data?.value ?? "";
    setSelectedCompanyId(value);
    setFilter((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, [key]: value, pageNo: 0 }));
  };
  const handlePIStatusChange = (data, key, action = {}) => {
    const value = data?.value ?? "";

    if (action.action === "clear" || value === "") {
      setFilter((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });

      setFilterPagination((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return { ...updated, pageNo: 0 };
      });

      setCurrentPage(1);
      return;
    }

    setFilter((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, [key]: value, pageNo: 0 }));
  };

 useEffect(() => {
   if(filter?.abNumber){
    setSearchFlag(true)
   }else if(filter?.projectRef){
    setSearchFlagPrj(true)
   }else{
    setSearchFlag(false)
    setSearchFlagPrj(false)
   }
  }, [filter]);
  const handleInputChange = (event, key) => {
    const updatedFilter = { ...filter, [key]: event.target.value.toUpperCase() };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, [key]: event.target.value.toUpperCase(), pageNo: 0 }));
  };
  const handleSearchClick = () => {

    const updatedFilter = { ...filter, abNumber: abNumber, year: "", loadingWeek: "", status: "", fromDate: "", toDate: "" };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, abNumber: abNumber, pageNo: 0, year: "", loadingWeek: "", status: "", fromDate: "", toDate: "" }));
    setSearchFlag(true)

  }
  const handleClearClick = () => {
    setAbNumber("")
    const updatedFilter = { ...filter, abNumber: "" };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, abNumber: "", pageNo: 0 }));
    setSearchFlag(false)

  }
  const handleSearchClickPrj = () => {

    const updatedFilter = { ...filter, projectRef: projectRef, year: "", loadingWeek: "", status: "", fromDate: "", toDate: "" };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, projectRef: projectRef, pageNo: 0, year: "", loadingWeek: "", status: "", fromDate: "", toDate: "" }));
    setSearchFlagPrj(true)

  }
  const handleClearClickPrj = () => {
    setProjectRef("")
    const updatedFilter = { ...filter, projectRef: "" };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, projectRef: "", pageNo: 0 }));
    setSearchFlagPrj(false)

  }
  const handleDateChange = (date, key) => {
    const updatedFilter = { ...filter, [key]: date === null ? null : moment(date).format("YYYY-MM-DD") };
    setFilter(updatedFilter);
    setCurrentPage(1);
    setFilterPagination((prev) => ({ ...prev, [key]: date === null ? null : moment(date).format("YYYY-MM-DD"), pageNo: 0 }));
    // console.log('updatedFilter', updatedFilter)
  };
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setFilterPagination((prev) => ({
      ...prev,
      pageNo: newPage - 1,
    }));
  };
  // const handlePageChange = (event, newPage) => {
  //   setFilter((prevFilter) => ({
  //     ...prevFilter,
  //     pageNo: newPage - 1,
  //   }));
  // };
  const handleMoveOrders = (
    selectedRows,
    containerPlan,
    gridApi,
    selectedContainer
  ) => {
    const moveOrder = containerPlanList.find(
      (item) => item.containerNo === containerPlan.value
    );
    if (moveOrder) {
      const updatedContainer = containerPlanList.map((c) => {
        return c.id === moveOrder.id
          ? { ...c, orders: [...c.orders, ...selectedRows] }
          : c; //
      });
      const selectedContainerIds = selectedRows.map((item) => item.id);

      const newContainerList = updatedContainer.map((c) => {
        return c.id === selectedContainer.id
          ? {
            ...c,
            orders: c.orders.filter(
              (item) => !selectedContainerIds.includes(item.id)
            ),
          }
          : c; //
      });

      gridApi.api.applyTransaction({
        remove: selectedRows,
      });
      setContainerPlanList(newContainerList);
      toast.success(
        `Orders are move to container ${moveOrder.containerNo} Successfully`
      );
    }
  };

  const [selectedContainerIds, setSelectedContainerIds] = useState([]);
  const [selectedContainerNo, setSelectedContainerNo] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [showEditAlert, setShowEditAlert] = useState(false);
  const [bookingContent, setBookingContent] = useState();
  const [bookingTitle, setBookingTitle] = useState("");

  const handleCheckboxChange = (container) => {
    const filteredContainer = {
      id: container.id,
      containerNo: container.containerNo,
      destination: container.destination,
      status: container.containerStatus,
      plannedLoadingWeek: container.plannedLoadingWeek,
      orderTotalVolume: container.orderTotalVolume,
      orderTotalWeight: container.orderTotalWeight,
      forwarderName: container.forwarderInfo?.name,
      forwarderNumber: container.forwarderInfo?.contact,
      forwarderEmail: container.forwarderInfo?.emailAddress,
      totalOrders: container.orders?.length || 0,
      containerType: container?.actualContainerType?.uniqueCode,
      proformaStatus: container?.proformaStatus,
      plannedLoadingYear: container?.plannedLoadingYear,
      orders: container?.orders?.map((order, index) => ({
        slNo: index + 1,
        abNumber: order.abNumber,
        commissionName: order.commissionName,
        volume: order.volume,
        product: order.vendorName,
      })),

      vendors: container?.orders
        ? [...new Set(container.orders.map((order) => order.vendorShortKey))]
        : null,
    };

    setSelectedContainerIds((prevSelected) => {
      const exists = prevSelected.some((item) => item.id === container.id);
      return exists
        ? prevSelected.filter((item) => item.id !== container.id)
        : [...prevSelected, filteredContainer];
    });
  };
  const getFreshSelectedContainers = useCallback(() => {
  return containerPlanList
    .filter((container) =>
      selectedContainerIds.some((selected) => selected.id === container.id)
    )
    .map((container) => ({
      id: container.id,
      containerNo: container.containerNo,
      destination: container.destination,
      status: container.containerStatus,
      plannedLoadingWeek: container.plannedLoadingWeek,
      orderTotalVolume: container.orderTotalVolume,
      orderTotalWeight: container.orderTotalWeight,
      forwarderName: container.forwarderInfo?.name,
      forwarderNumber: container.forwarderInfo?.contact,
      forwarderEmail: container.forwarderInfo?.emailAddress,
      totalOrders: container.orders?.length || 0,
      containerType: container?.actualContainerType?.uniqueCode,
      proformaStatus: container?.proformaStatus,
      plannedLoadingYear: container?.plannedLoadingYear,
      orders: container?.orders?.map((order, index) => ({
        slNo: index + 1,
        abNumber: order.abNumber,
        commissionName: order.commissionName,
        volume: order.volume,
        product: order.vendorName,
      })),
      vendors: container?.orders
        ? [...new Set(container.orders.map((order) => order.vendorShortKey))]
        : null,
    }));
}, [containerPlanList, selectedContainerIds]);
  useEffect(() => {
    const count = selectedContainerIds?.length || 0;
    setSelectedContainerNo(count > 0 ? count : null);
    if (selectedContainerIds.length > 0) {
      const hasCloseStatus = selectedContainerIds.some(
        (container) => container.status === 'CLOSE'
      );
      setBtnDisable(!hasCloseStatus);
    } else {
      setBtnDisable(true);
    }
  }, [selectedContainerIds]);
  const bookingEmailContentFactory = () => {
    return (
      <>
        <p>Please find the list of order/s to be booked in above container/s.</p>
        <p>Please arrange to book them to requested Loading Week/s </p>
        <p>Forward us the pending ABs (if any) to proceed further.</p>
        <p>
          Note: Please don’t release them for production until we send you the
          official release request.
        </p>
      </>
    );
  };
  const releaseRequestEmailContent = () => {
    return (
      <>
        <p>Please find the list of order/s to be loaded in the container/s</p>
        <p>Please arrange to release them for production and loading on week as planned </p>
        <p>Payment for the same will be transferred from Nolte FZE.</p>
      </>
    );
  };
  const bookingEmailContentNfze = () => {
    return (
      <>
        <p>The above containers are closed and ready for booking.</p>
        <p>Please proceed with booking as per the plan.</p>

      </>
    );
  };
  const approvalContent = () => {
    return (
      <>
        <p>
          Please arrange to release the below orders for production & loading on
          week 6 as per the final container plan listed below.
        </p>
        <p>Payment for the same will be transferred from Nolte FZE.</p>
      </>
    );
  };
  const booingApproval = () => {
    return (
      <>
        <p>
          Booking Request Approval
        </p>
      </>
    );
  };

  const USER_ROLES = "ROLE_PARTNER";
  const REQ_STATUS = [
    "Booking request sent to factory",
    "Booking request sent to NFZE",
    "Booked",
    "Ready to Release",
    "Released",
    "Loaded",
  ];
  const REQ_STATUS_REQUEST = [
    "Booking request sent to factory",
    "Booking request sent to NFZE",
    "Booked",
    "Ready to Release",
    "Released",
  ];
  const REQ_STATUS_BOOK = [
    "Booked",
    "Ready to Release",
    "Released"
  ];
  const REQ_STATUS_RELEASE = [
    "Ready to Release",
    "Released",
  ];
  const REQ_STATUS_LOAD = [
    "Loaded",
  ];
  const handleBookingToFactory = (endPoint, title, emailBody) => {
    if (selectedContainerIds.length > 0) {
      let AlreadyBooked = [];

      // if ( endPoint === "releaseApprovalRequest") {
      //   selectedContainerData = containerPlanList.filter((container) =>
      //     selectedContainerIds.includes(container.id)
      //   );
      // } 
      // else 
      if (endPoint === "bookingToNfze" || endPoint === "bookingToFactory" || endPoint === "bookingRequestRelease") {  //if it is requested Already

        // selectedContainerData = containerPlanList.filter(
        //   (container) =>
        //     selectedContainerIds.includes(container.id) &&!REQ_STATUS_REQUEST.includes(container.containerStatus)
        // );
        // AlreadyBooked = containerPlanList.filter(
        //   (container) =>
        //     selectedContainerIds.includes(container.id) &&
        //     REQ_STATUS_REQUEST.includes(container.containerStatus)
        // );

        // else if(endPoint=== "bookingApprovalRequest") {
        //   selectedContainerData = containerPlanList.filter(
        //     (container) =>
        //       selectedContainerIds.includes(container.id) &&
        //       !REQ_STATUS_BOOK.includes(container.containerStatus)
        //   );

        //   AlreadyBooked = containerPlanList.filter(
        //     (container) =>
        //       selectedContainerIds.includes(container.id) &&
        //       REQ_STATUS_BOOK.includes(container.containerStatus)
        //   );
        // }
        // else if(endPoint=== "release") {
        //   selectedContainerData = containerPlanList.filter(
        //     (container) =>
        //       selectedContainerIds.includes(container.id) &&
        //       !REQ_STATUS_RELEASE.includes(container.containerStatus)
        //   );

        //   AlreadyBooked = containerPlanList.filter(
        //     (container) =>
        //       selectedContainerIds.includes(container.id) &&
        //       REQ_STATUS_RELEASE.includes(container.containerStatus)
        //   );
        // }


        setAlreadyBookedContainer(AlreadyBooked);
        // console.log("selected container", selectedContainerData);
        // console.log("selected AlreadyBooked", AlreadyBooked);
        setShowAlert(false);
        setOpenBookingRequest(true);
        const bookingContainerInfo = containerPlanList
          .filter((container) =>
            selectedContainerIds.some((selected) => selected.id === container.id)
          )
          .map((container) => ({
            id: container.id,
            containerNo: container.containerNo,
            containerType: container?.actualContainerType?.uniqueCode,
            destination: container.destination,
            plannedLoadingWeek: container.plannedLoadingWeek,
            totalOrders: container.orders?.length || 0,
            orderTotalVolume: container.orderTotalVolume,
            orderTotalWeight: container.orderTotalWeight,
            vendors: container?.orders
              ? [
                ...new Set(
                  container.orders.map((order) => order.vendorShortKey)
                ),
              ]
              : null,
            forwarderName: container.forwarderInfo?.name,
          }));

        // setBookingContainer(selectedContainerIds);
         setBookingContainer(getFreshSelectedContainers());
        setBookingApiEndpoint(endPoint);
        setBookingContent(emailBody);
        setBookingTitle(title);
      }
    } else {
      setShowAlert(true);
    }
  };
  const handleSendBooking = async () => {
    setBtnDisableBooking(true);
    const bookingContainerId = bookingContainer.map((obj) => obj.id);


    const payload = {
      containerIds: bookingContainerId,
      ...(bookingComment &&
        bookingComment.trim() && {
        comment: bookingComment.trim(),
      }),
    };

    try {
      if (bookingApiEndpoint === "bookingToNfze") {
        await OAuthService.addData(`${getContainersUrl}/sendBookingReqToNFZE`, payload);

      } else if (bookingApiEndpoint === "bookingToFactory") {
        await OAuthService.addData(`${getContainersUrl}/sendBookingRequest`, payload);

      } else if (bookingApiEndpoint === "bookingRequestRelease") {
        await OAuthService.addData(`${getContainersUrl}/sendReleaseRequest`, payload);

      } else if (bookingApiEndpoint === "bookingApprovalRequest") {
        const bookingContainerId = bookingContainer.map((obj) => obj.id);
        await OAuthService.patchData(`${getContainersUrl}/approvalReqForBooking`, bookingContainerId);

      } else if (bookingApiEndpoint === 'releaseApprovalRequest') {
        const bookingContainerId = bookingContainer.map((obj) => obj.id);
        await OAuthService.patchData(`${getContainersUrl}/approvalReqForRelease`, bookingContainerId);

      }
      setOpenBookingRequest(false);
      setBookingComment("");
      toast.success(bookingApiEndpoint === "bookingToNfze" || bookingApiEndpoint === "bookingToFactory" ? "Container Booking Request send successfully" : "Container Release Request send successfully");
      getContainerPlans();
      getOrderList();
      setSelectedContainerIds([]);
    } catch (error) {
      toast.error(error?.response?.data || error?.response?.data?.errorMessage || error.message)
      setBookingComment("")
      setOpenBookingRequest(false);
      // console.log(error)
      //  console.log(error.message);
      // setError(error.message)
    } finally {
      setBtnDisableBooking(false);
    }
  };

  const handleApprovalBooking = async (status) => {
    if (selectedContainerIds.length > 0) {
      let selectedContainerData = containerPlanList.filter((container) =>
        selectedContainerIds.includes(container.id)
      );
      const containerId = selectedContainerData.map(item => item.id)
      try {
        const payload = {
          containerIds: containerId,
          approvedFor: filter.specialApprovalName,
          status: status,
        }
        await OAuthService.patchData(`${getContainersUrl}/approveBookingOrRelease`, payload);
        setSuccessMsg("Container Updated Successfully");
        setSnackState(true);
        getContainerPlans();
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message)
        // console.log(error.message);
        // setError(error.message)
      }
    } else {
      setShowAlert(true);
    }
  }

  const checkCustomerCheckboxes = (role, status) => {
    if (role.includes(USER_ROLES) && REQ_STATUS.includes(status)) {
      return false;
    }
    return true;
  };

  const getCurrentWeek = (currentDate) => {
    currentDate.setMonth(0, 1);
    const dayOfWeek = currentDate.getDay();
    const offset = dayOfWeek > 0 ? 8 - dayOfWeek : 1;
    const daysPassed = Math.floor(
      (new Date() - currentDate) / (24 * 60 * 60 * 1000)
    );
    const currentWeek = Math.ceil((daysPassed + offset) / 7);
    setCurrentWeek(currentWeek);
    return currentWeek;
  };

  useEffect(() => {
    getCurrentWeek(new Date());
  }, []);

  useEffect(() => {
    const total = rowData?.reduce((a, b) => a + Number(b.volume), 0);
    setTotalAllVolume(total);
  }, [rowData]);

  const approvalOptions = [
    { value: 'release', label: 'Release' },
    { value: 'booking', label: 'Booking' },
  ]

  return (
    <>
      {isMobile && (
        <Alert severity="info" sx={{ borderRadius: 0 }}>
          Please use a desktop screen for more functions.
        </Alert>
      )}
      <FormPageHeader
        componentName="Container Management"
        pageName="Container Management"
        currentPage={"Container Management"}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
        orderHeaderAction={orderHeaderAction()}
        gridRef={!hasLogisticsRole && gridRef}
        // handleSubmit={handleSaveContainer}
      >
        {useTopFilters && (
          <Box className="px-16 py-4" sx={{ pb: 1 }}>
            {isMobile && (
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => setShowMobileFilters((prev) => !prev)}
                startIcon={<FilterListIcon />}
                endIcon={
                  <ExpandMoreIcon
                    sx={{
                      transform: showMobileFilters
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                  />
                }
                sx={{ mb: 1 }}
              >
                {showMobileFilters ? "Hide Filters" : "Show Filters"}
              </Button>
            )}
            <Collapse in={!isMobile || showMobileFilters} unmountOnExit>
              <Box
                className="flex w-full"
                sx={{
                  alignItems: "stretch",
                  justifyContent: "space-between",
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? 2 : 0,
                }}
              >
                <Box className="flex flex-col flex-grow" sx={{ gap: 2 }}>
                  <Box className="flex flex-wrap" sx={{ gap: 2 }}>
                    <Box className=" flex gap-4 ">
                      {/* Week Dropdown */}
                      <Select
                        placeholder="Loading Week"
                        options={weekOptions}
                        value={
                          weekOptions.find(
                            (w) => w.value === filter.loadingWeek,
                          ) || null
                        }
                        onChange={handleWeekChange}
                        styles={customStyles()}
                        className="w-full whitespace-nowrap"
                        isClearable
                      />
                      {/* Year Dropdown */}
                      <Select
                        placeholder=" Year"
                        options={yearOptions}
                        value={
                          yearOptions.find((y) => y.value === filter.year) ||
                          null
                        }
                        onChange={handleYearChange}
                        styles={customStyles()}
                        className="w-full"
                        isClearable={true}
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <TextField
                        type="text"
                        label="Container No."
                        variant="outlined"
                        fullWidth
                        name="containerNo"
                        value={filter.containerNo}
                        onChange={(e) => handleInputChange(e, "containerNo")}
                      />
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <Select
                        placeholder="Destination"
                        options={destinationOptions}
                        styles={customStyles()}
                        className="w-full"
                        name="destination"
                        value={
                          filter.listPort?.length
                            ? destinationOptions.filter((obj) =>
                                filter.listPort.includes(obj.label),
                              )
                            : []
                        }
                        onChange={(e, action) =>
                          handleSelectDestinationChange(e, "listPort", action)
                        }
                        isClearable
                        isMulti
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <Select
                        placeholder={"Status"}
                        options={statusOptions}
                        styles={customStyles()}
                        className="w-full"
                        name="status"
                        value={
                          statusOptions.find(
                            (option) => option.value === filter.status,
                          ) || null
                        }
                        // value={
                        //   filter.status &&
                        //   statusOptions &&
                        //   statusOptions.filter(
                        //     (obj) => filter.status === obj.value
                        //   )
                        // }
                        onChange={(e) => handleSelectChange(e, "status")}
                      />
                    </Box>
                  </Box>

                  <Box className="flex flex-wrap" sx={{ gap: 2 }}>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <CustomDatePicker
                        label="From"
                        className="w-full"
                        format={"dd-MM-yyyy"}
                        name={"fromDate"}
                        value={filter.fromDate}
                        maxDate={filter.toDate && new Date(filter.toDate)}
                        handleChange={(e) => handleDateChange(e, "fromDate")}
                        componentsProps={{
                          actionBar: { actions: ["clear"] },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <CustomDatePicker
                        label="To"
                        className="w-full"
                        format={"dd-MM-yyyy"}
                        name={"toDate"}
                        value={filter.toDate}
                        minDate={filter.fromDate && new Date(filter.fromDate)}
                        handleChange={(e) => handleDateChange(e, "toDate")}
                        componentsProps={{
                          actionBar: { actions: ["clear"] },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <Select
                        placeholder="Proforma Status"
                        options={proformaStatusOptions}
                        styles={customStyles()}
                        className="w-full"
                        name="piStatus"
                        isClearable
                        value={
                          proformaStatusOptions.find(
                            (option) => option.value === filter.proformaStatus,
                          ) || null
                        }
                        onChange={(e) =>
                          handlePIStatusChange(e, "proformaStatus")
                        }
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <TextField
                        type="text"
                        label="Ab Number"
                        variant="outlined"
                        placeholder="Search by AB Number"
                        fullWidth
                        name="abNumber"
                        value={filter?.abNumber ? filter.abNumber : abNumber}
                        onChange={(e) => setAbNumber(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" && abNumber.length <= 1) {
                            handleClearClick();
                          }
                        }}
                        InputProps={{
                          endAdornment: !searchFlag ? (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleSearchClick}
                                color="inherit"
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ) : (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClearClick}
                                color="inherit"
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 200 }}>
                      <TextField
                        type="text"
                        label="Project Ref"
                        variant="outlined"
                        placeholder="Search by Project Ref"
                        fullWidth
                        name="projectRef"
                        value={
                          filter?.projectRef ? filter.projectRef : projectRef
                        }
                        onChange={(e) => setProjectRef(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" && projectRef.length <= 1) {
                            handleClearClickPrj();
                          }
                        }}
                        InputProps={{
                          endAdornment: !searchFlagPrj ? (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleSearchClickPrj}
                                color="inherit"
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ) : (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClearClickPrj}
                                color="inherit"
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box
                  className="  flex items-center justify-center flex-col  border-2  rounded-lg p-8"
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    borderColor: theme.palette.divider,
                  }}
                  sx={{
                    width: isMobile ? "100%" : 180,
                    ml: isMobile ? 0 : 3,
                    p: 2,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Typography sx={{ fontSize: 12, textAlign: "center" }}>
                    Total No. of Containers
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: 18 }}>
                    {totalContainerCount}
                  </Typography>
                </Box>
              </Box>
            </Collapse>
          </Box>
        )}
      </FormPageHeader>
      <Grid container xs={12}>
        {ordersPanelVisible && (
          <Grid item xs={7.5}>
            <div style={gridStyle} className="ag-theme-alpine-dark grid">
              <AgGridReact
                ref={gridRef}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowData={rowData}
                rowSelection="multiple"
                context={{ lacqueredRanges }}
                // onRowDoubleClicked={onRowDoubleClicked}
                onRowDoubleClicked={onRowDoubleClicked}
                rowGroupPanelShow={"always"}
                cacheBlockSize={20}
                cacheOverflowSize={2}
                maxBlocksInCache={2}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onFilterChanged={onFilterChanged}
                onColumnMoved={onColumnStateChanged}
                onColumnPinned={onColumnStateChanged}
                onColumnVisible={onColumnStateChanged}
                onColumnResized={onColumnStateChanged}
                onColumnRowGroupChanged={onColumnGroupChange}
                animateRows={true}
                wrapHeaderText={true}
                headerHeight={28}
                rowHeight={22}
                suppressDragLeaveHidesColumns={true}
                rowDragManaged={
                  !(
                    hasPartnerShwMngrRole ||
                    hasPartnerOrderProRole ||
                    hasIAMRole
                  )
                }
                rowDragEntireRow={
                  !(
                    hasPartnerShwMngrRole ||
                    hasPartnerOrderProRole ||
                    hasIAMRole
                  )
                }
                rowDragMultiRow={
                  !(
                    hasPartnerShwMngrRole ||
                    hasPartnerOrderProRole ||
                    hasIAMRole
                  )
                }
                onSelectionChanged={onSelectionChanged}
              />
            </div>
            <Box
              className="flex justify-between"
              style={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              }}
              sx={{
                fontSize: 11,
                padding: "3px 10px",
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderTop: "none",
              }}
            >
              <div className="text-left">
                Orders Volume: <strong>{totalAllVolume.toFixed(3)}</strong>
              </div>
              <div className="text-right">
                Selected Orders Volume: <strong>{selectedOrderVol()}</strong>
              </div>
            </Box>
          </Grid>
        )}
        <Grid
          item
          xs={useTopFilters ? 12 : 4.5}
          className={clsx(classes.root, "relative")}
        >
          <div className="FusePageSimple-content w-full">
            <div className="flex flex-col w-full">
              {!useTopFilters && (
                <div
                  className="sticky top-0 z-10  p-8"
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    borderColor: theme.palette.divider,
                  }}
                >
                  {!hasLogisticsRole && (
                    <Box className="flex items-center gap-8  ">
                      <Box className="flex flex-col gap-4">
                        <Box className="flex items-center gap-4">
                          <Box>
                            <Box className=" flex gap-4 mb-6 px-4">
                              {/* Week Dropdown */}
                              <Select
                                placeholder="Loading Week"
                                options={weekOptions}
                                value={
                                  weekOptions.find(
                                    (w) => w.value === filter.loadingWeek,
                                  ) || null
                                }
                                onChange={handleWeekChange}
                                styles={customStyles()}
                                className="w-full whitespace-nowrap"
                                isClearable
                              />
                              {/* Year Dropdown */}
                              <Select
                                placeholder=" Year"
                                options={yearOptions}
                                value={
                                  yearOptions.find(
                                    (y) => y.value === filter.year,
                                  ) || null
                                }
                                onChange={handleYearChange}
                                styles={customStyles()}
                                className="w-full"
                                isClearable={true}
                              />
                            </Box>

                            <Box className="mb-6 px-4">
                              <TextField
                                type="text"
                                label="Container No."
                                variant="outlined"
                                style={{ color: theme.palette.text.primary }}
                                fullWidth
                                name="containerNo"
                                value={filter.containerNo}
                                onChange={(e) =>
                                  handleInputChange(e, "containerNo")
                                }
                              />
                            </Box>
                            <Box className="px-4 mb-6">
                              <CustomDatePicker
                                label="From"
                                className="w-full"
                                format={"dd-MM-yyyy"}
                                name={"fromDate"}
                                value={filter.fromDate}
                                maxDate={
                                  filter.toDate && new Date(filter.toDate)
                                }
                                handleChange={(e) =>
                                  handleDateChange(e, "fromDate")
                                }
                                componentsProps={{
                                  actionBar: { actions: ["clear"] },
                                }}
                              />
                            </Box>
                            <Box className="px-4">
                              <TextField
                                type="text"
                                label="Ab Number"
                                variant="outlined"
                                placeholder="Search by AB Number"
                                fullWidth
                                name="abNumber"
                                value={
                                  filter?.abNumber ? filter.abNumber : abNumber
                                }
                                onChange={(e) => setAbNumber(e.target.value)}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" &&
                                    abNumber.length <= 1
                                  ) {
                                    handleClearClick();
                                  }
                                }}
                                InputProps={{
                                  endAdornment: !searchFlag ? (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleSearchClick}
                                        color="inherit"
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ) : (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleClearClick}
                                        color="inherit"
                                      >
                                        <ClearIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Box>
                          </Box>
                          <Box>
                            <Box className="px-4 mb-6">
                              <Select
                                placeholder={"Destination"}
                                options={destinationOptions}
                                styles={customStyles()}
                                className="w-full"
                                name="destination"
                                value={
                                  filter.listPort?.length
                                    ? destinationOptions.filter((obj) =>
                                        filter.listPort.includes(obj.label),
                                      )
                                    : []
                                }
                                onChange={(e, action) =>
                                  handleSelectDestinationChange(
                                    e,
                                    "listPort",
                                    action,
                                  )
                                }
                                isClearable
                                isMulti
                              />
                            </Box>
                            <Box className="px-4 mb-6">
                              <Select
                                placeholder={"Status"}
                                options={statusOptions}
                                styles={customStyles()}
                                className="w-full"
                                name="status"
                                value={
                                  statusOptions.find(
                                    (option) => option.value === filter.status,
                                  ) || null
                                }
                                // value={
                                //   filter.status &&
                                //   statusOptions &&
                                //   statusOptions.filter(
                                //     (obj) => filter.status === obj.value
                                //   )
                                // }
                                onChange={(e) =>
                                  handleSelectChange(e, "status")
                                }
                              />
                            </Box>
                            <Box className="px-4 mb-6">
                              <CustomDatePicker
                                label="To"
                                className="w-full"
                                format={"dd-MM-yyyy"}
                                name={"toDate"}
                                value={filter.toDate}
                                minDate={
                                  filter.fromDate && new Date(filter.fromDate)
                                }
                                handleChange={(e) =>
                                  handleDateChange(e, "toDate")
                                }
                                componentsProps={{
                                  actionBar: { actions: ["clear"] },
                                }}
                              />
                            </Box>
                            <Box className="px-4">
                              <TextField
                                type="text"
                                label="Project Ref"
                                variant="outlined"
                                placeholder="Search by Project Ref"
                                fullWidth
                                name="projectRef"
                                value={
                                  filter?.projectRef
                                    ? filter?.projectRef
                                    : projectRef
                                }
                                onChange={(e) => setProjectRef(e.target.value)}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" &&
                                    projectRef.length <= 1
                                  ) {
                                    handleClearClickPrj();
                                  }
                                }}
                                InputProps={{
                                  endAdornment: !searchFlagPrj ? (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleSearchClickPrj}
                                        color="inherit"
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ) : (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleClearClickPrj}
                                        color="inherit"
                                      >
                                        <ClearIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>

                        <Box className="px-4">
                          <Select
                            placeholder="Proforma Status"
                            options={proformaStatusOptions}
                            styles={customStyles()}
                            className="w-full"
                            name="piStatus"
                            isClearable
                            value={
                              proformaStatusOptions.find(
                                (option) =>
                                  option.value === filter.proformaStatus,
                              ) || null
                            }
                            onChange={(e) =>
                              handlePIStatusChange(e, "proformaStatus")
                            }
                          />
                        </Box>
                      </Box>
                      <div className="flex flex-col gap-2">
                        <Box
                          className="flex items-center justify-center flex-col border-2  rounded-lg p-8 "
                          style={{
                            backgroundColor: theme.palette.background.paper,
                            borderColor: theme.palette.divider,
                          }}
                          sx={{ textAlign: "center" }}
                        >
                          <Typography sx={{ fontSize: 10 }}>
                            Total No. of Containers
                          </Typography>
                          <Typography sx={{ fontWeight: 600 }}>
                            {totalContainerCount}
                          </Typography>
                        </Box>
                        {selectedContainerNo > 0 && (
                          <Box
                            className="  border-2  rounded-lg p-8 flex items-center justify-center flex-col"
                            style={{
                              backgroundColor: theme.palette.background.paper,
                              borderColor: theme.palette.divider,
                            }}
                            sx={{ textAlign: "center" }}
                          >
                            <Typography sx={{ fontSize: 10 }}>
                              Selected No. of Containers
                            </Typography>
                            <Typography sx={{ fontWeight: 600 }}>
                              {selectedContainerNo}
                            </Typography>
                          </Box>
                        )}
                      </div>
                    </Box>
                  )}
                </div>
              )}
              {showAlert && (
                <Alert severity="error">Please select container</Alert>
              )}
              {loading && (
                <div className="flex justify-center py-24">
                  <CircularProgress color="secondary" size={18} />
                </div>
              )}
              <Box className="flex flex-wrap">
                {!hasPartnerOrderProRole &&
                  !hasPartnerShwMngrRole &&
                  !hasLogisticsRole &&
                  !hasIAMRole &&
                  !isMobile &&
                  isOpen && (
                    <div
                      id="emptyContainer"
                      className={`widget flex w-full p-10 ${
                        containerPlanList.length === 0
                          ? ""
                          : "sm:w-1/2 md:w-1/25"
                      }`}
                    >
                      <Paper
                        className="w-full rounded-8 shadow-none border-1 flex justify-center items-center"
                        style={
                          containerPlanList.length === 0
                            ? { height: "69vh" }
                            : {}
                        }
                      >
                        <Typography
                          className="text-center text-16"
                          sx={{ textTransform: "uppercase" }}
                        >
                          Drag your <br />
                          order here
                        </Typography>
                      </Paper>
                    </div>
                  )}
                {containerPlanList.map((row, index) => {
                  let totalOrderVolume = 0;
                  if (row?.orders?.length) {
                    row?.orders.forEach((item) => {
                      totalOrderVolume = totalOrderVolume + Number(item.volume);
                    });
                  }
                  return (
                    <div
                      key={row.id}
                      id={row.id}
                      className={`widget flex w-full p-10 ${
                        hasLogisticsRole || (hasSuperRole && !isOpen)
                          ? "sm:w-1/4 md:w-1/4"
                          : "sm:w-1/2 md:w-1/2"
                      }`}
                    >
                      <Paper
                        className={
                          row.id === activeContainer
                            ? "active-container w-full rounded-8 shadow-none border-1"
                            : "w-full rounded-8 shadow-none border-1"
                        }
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          minHeight: 210,
                        }}
                      >
                        <div className="flex items-center justify-between pl-10 pr-4 pt-10">
                          <div>
                            <Typography
                              className="text-12"
                              color="textSecondary"
                              component={"div"}
                            >
                              <div className="truncate">Type</div>
                              <b>{row?.actualContainerType?.uniqueCode}</b>
                            </Typography>
                          </div>
                          {row?.region && (
                            <div className="flex flex-auto items-center justify-center text-center py-4">
                              <Typography
                                className="text-12"
                                color="textSecondary"
                                component={"div"}
                              >
                                <div className="truncate">Region</div>
                                <b>{row?.region}</b>
                              </Typography>
                            </div>
                          )}
                          <div>
                            <Typography
                              className="text-12"
                              color="textSecondary"
                              component={"div"}
                            >
                              <div className="truncate">Destination</div>
                              <b>{row?.destination.toUpperCase()}</b>
                            </Typography>
                          </div>
                        </div>
                        <div className="flex items-center justify-center flex-1">
                          <div className="flex items-center gap-8">
                            {row.errorMessage?.trim() && (
                              <Tooltip
                                title={row.errorMessage || ""}
                                disableHoverListener={!row.errorMessage}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "0.875rem",
                                      backgroundColor: "#f44336",
                                      color: "white",
                                      padding: "8px 12px",
                                      borderRadius: "4px",
                                      maxWidth: 300,
                                      whiteSpace: "pre-line",
                                    },
                                  },
                                }}
                              >
                                <img
                                  className="w-44 my-32"
                                  src="assets/images/logo/error-icon.svg"
                                  alt="logo"
                                />
                              </Tooltip>
                            )}
                            <div className="text-center py-12">
                              <Typography
                                className="text-16 leading-none"
                                color="secondary"
                              >
                                {row?.containerStatus == "Loaded" ||
                                  (checkCustomerCheckboxes(
                                    token.scope,
                                    row?.containerStatus,
                                  ) && (
                                    <Checkbox
                                      sx={{ p: 0, marginTop: -1 }}
                                      checked={selectedContainerIds.some(
                                        (c) => c.id === row.id,
                                      )}
                                      onChange={() => handleCheckboxChange(row)}
                                      disabled={
                                        !(
                                          hasSuperRole || hasPartnerAdminRole
                                        ) && row?.containerStatus === "OPEN"
                                          ? true
                                          : false
                                      }
                                    />
                                  ))}{" "}
                                {row?.containerNo}
                              </Typography>
                              <Typography
                                className="text-12"
                                color="textSecondary"
                              >
                                Status: {row?.containerStatus}
                              </Typography>
                              {row?.proformaStatus && (
                                <Typography
                                  className="text-12"
                                  color="textSecondary"
                                >
                                  Proforma Status: {row?.proformaStatus}
                                </Typography>
                              )}
                              {row?.orders.length > 0 && (
                                <Typography
                                  className="text-12"
                                  color="textSecondary"
                                >
                                  Product:{" "}
                                  {[
                                    ...new Set(
                                      row.orders.map(
                                        (order) => order.vendorShortKey,
                                      ),
                                    ),
                                  ].join(", ")}
                                </Typography>
                              )}

                              <Box className="flex px-10 justify-center">
                                <div>
                                  <IconButton
                                    onClick={() => handleViewContainer(row)}
                                  >
                                    <FuseSvgIcon size={16}>
                                      heroicons-outline:eye
                                    </FuseSvgIcon>
                                  </IconButton>
                                  {!hasPartnerOrderProRole &&
                                    !hasPartnerShwMngrRole &&
                                    !hasIAMRole && (
                                      <>
                                        {!(
                                          hasPartnersRole &&
                                          row.containerStatus !== "OPEN"
                                        ) && (
                                          <IconButton
                                            onClick={() =>
                                              handleEditContainer(row)
                                            }
                                          >
                                            <FuseSvgIcon size={14}>
                                              heroicons-outline:pencil
                                            </FuseSvgIcon>
                                          </IconButton>
                                        )}

                                        {!(
                                          hasPartnersRole &&
                                          row.containerStatus !== "OPEN"
                                        ) &&
                                          !hasLogisticsRole && (
                                            <IconButton
                                              onClick={() => {
                                                setOpenDeleteModel(true);
                                                setDeleteContainerData(row);
                                              }}
                                            >
                                              <FuseSvgIcon size={14}>
                                                heroicons-outline:trash
                                              </FuseSvgIcon>
                                            </IconButton>
                                          )}
                                      </>
                                    )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center px-10 w-full border-t divide-x">
                          <div className="flex flex-auto items-center justify-center text-center py-4">
                            <Typography
                              className="text-12"
                              color="textSecondary"
                              component={"div"}
                            >
                              <div className="truncate">Volume</div>
                              <b>{parseFloat(totalOrderVolume).toFixed(3)}</b>
                            </Typography>
                          </div>
                          <div className="flex flex-auto items-center justify-center text-center py-4">
                            <Typography
                              className="text-12"
                              color="textSecondary"
                              component={"div"}
                            >
                              <div className="truncate">Total Orders</div>
                              <b>{row?.orders?.length}</b>
                            </Typography>
                          </div>
                          <div className="flex flex-auto items-center justify-center text-center py-4">
                            <Typography
                              className="text-12"
                              color="textSecondary"
                              component={"div"}
                            >
                              <div className="truncate">Loading Week</div>
                              <b>
                                {row?.plannedLoadingWeek
                                  ? row?.plannedLoadingWeek +
                                    "/" +
                                    row?.plannedLoadingYear
                                  : "-"}
                              </b>
                            </Typography>
                          </div>
                        </div>
                      </Paper>
                    </div>
                  );
                })}
                {/* {containerPlanList.length === 0 && !hasPartnerOrderProRole && !hasMDRole && (
                  <div id="test" className="widget flex w-full p-10">
                    <Paper
                      className="w-full rounded-8 shadow-none border-1 flex justify-center items-center"
                      sx={{ height: "69vh" }}
                    >
                      <Typography
                        variant="h3"
                        component="h2"
                        className="text-center text-uppercase"
                        sx={{ textTransform: "uppercase" }}
                      >
                        Drag your <br />
                        order here
                      </Typography>
                    </Paper>
                  </div>
                )} */}
              </Box>
              {containerCount > 1 && (
                <Pagination
                  variant="outlined"
                  count={containerCount}
                  page={currentPage}
                  onChange={handlePageChange}
                  className="flex justify-center"
                />
              )}
            </div>
          </div>
        </Grid>
      </Grid>
      <Dialog open={openDeleteModel} onClose={handleCloseDeleteModel}>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this container? Once deleted, the
            container cannot be recovered.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              handlePurge(deleteContainerData);
              setOpenDeleteModel(false);
            }}
          >
            Yes
          </Button>
          <Button onClick={handleCloseDeleteModel} variant="outlined" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <AddContainerDialog
        open={openDialog}
        onClose={handleDialogClose}
        containerTypeOptions={containerTypeOptions}
        loadingWeekOptions={loadingWeekOptions}
        regionOptions={regionOptions}
        handleSubmit={handleSubmit}
        checkSubmit={checkSubmit}
        filteredLoadingWeek={filteredLoadingWeek}
        // generateId={generateId}
        // btnDisable={btnDisable}
        hasPartner={hasPartnerAdminRole}
        selectedCompanyId={selectedCompanyId}
        hasSuperRole={hasSuperRole}
      />
      <ViewContainer
        open={openViewContainer}
        onClose={handleDialogClose}
        selectedContainer={selectedContainer}
        data={containerPlanList}
        filteredLoadingWeek={filteredLoadingWeek}
        hasPartner={hasPartnerAdminRole}
        hasPartnerOrderProRole={hasPartnerOrderProRole}
        hasPartnerShwMngrRole={hasPartnerShwMngrRole}
        hasSuperRole={hasSuperRole}
        lacqueredRanges={lacqueredRanges}
      />
      <EditContainer
        setSelectedContainer={setSelectedContainer}
        open={openEditContainer}
        onClose={handleEditDialogClose}
        selectedContainer={selectedContainer}
        containerTypeOptions={containerTypeOptions}
        regionOptions={regionOptions}
        loadingWeekOptions={loadingWeekOptions}
        setLoadingWeekOptions={setLoadingWeekOptions}
        data={containerPlanList}
        handleEditSubmit={handleEditSubmit}
        handleMoveOrders={handleMoveOrders}
        showEditAlert={showEditAlert}
        filteredLoadingWeek={filteredLoadingWeek}
        hasPartner={hasPartnerAdminRole}
        lacqueredRanges={lacqueredRanges}
        onConfirmEdit={handleConfirmEdit}
        containerTypeList={containerType}
        hasPartnerOrderProRole={hasPartnerOrderProRole}
        hasPartnerShwMngrRole={hasPartnerShwMngrRole}
        hasSuperRole={hasSuperRole}
        isValidLoadingWeeks={isValidLoadingWeeks}
        uniqueLoadingWeek={uniqueLoadingWeek}
      />
      <ContainerForm
        open={openContainerForm}
        onClose={handleContainerFormClose}
        newOrder={newOrder}
        containerTypeOptions={containerTypeOptions}
        regionOptions={regionOptions}
        loadingWeekOptions={loadingWeekOptions}
        setLoadingWeekOptions={setLoadingWeekOptions}
        handleNewContainer={handleNewContainer}
        containerTypeList={containerType}
        setOpenContainerForm={setOpenContainerForm}
        filteredLoadingWeek={filteredLoadingWeek}
        hasPartner={hasPartnerAdminRole}
        selectedCompanyId={selectedCompanyId}
        lacqueredRanges={lacqueredRanges}
        isValidLoadingWeeks={isValidLoadingWeeks}
        uniqueLoadingWeek={uniqueLoadingWeek}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        formData={formData}
        setFormData={setFormData}
        uniqueLoadingYear={uniqueLoadingYear}
        hasSuperRole={hasSuperRole}
      />
      <BookingRequestDialog
        open={openBookingRequest}
        onClose={handleDialogClose}
        bookingContainer={bookingContainer}
        handleSendBooking={handleSendBooking}
        bookingContent={bookingContent}
        bookingTitle={bookingTitle}
        alreadyBookedContainer={alreadyBookedContainer}
        bookingApiEndpoint={bookingApiEndpoint}
        bookingComment={bookingComment}
        setBookingComment={setBookingComment}
        btnDisableBooking={btnDisableBooking}
        token={token}
      />

      <Dialog open={openWarningAlert} onClose={handleDialogClose}>
        <DialogContent>
          <DialogContentText>
            Your selected orders have different loading week or customers,
            Please select another container
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openWarningAlertContainerStatus}
        onClose={handleDialogClose}
      >
        <DialogContent>
          <DialogContentText>
            You are not allowed to add orders to this container as it is already
            in the process of booking or releasing. Please contact your Nolte
            FZE Account Manager for further assistance or select another
            container.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openWarningAlertVolume} onClose={handleDialogCloseVolume}>
        <DialogContent>
          <DialogContentText>
            The order volume you've selected exceeds the maximum capacity of the
            current container. To proceed, please choose a different container
            that can accommodate the volume, or create a new container with
            sufficient capacity.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogCloseVolume} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openForwarderInfo}
        onClose={handleDialogCloseForwarderInfo}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          position="static"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Forwarder Information
            </Typography>
            <IconButton
              onClick={handleDialogCloseForwarderInfo}
              color="inherit"
            >
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={forwarder.name || ""}
                onChange={handleForwarderDetailsChange}
                variant="outlined"
                type="text"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Contact Number"
                name="contact"
                value={forwarder.contact || ""}
                onChange={handleForwarderDetailsChange}
                variant="outlined"
                type="text"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={forwarder.email || ""}
                onChange={handleForwarderDetailsChange}
                variant="outlined"
                type="email"
                autoComplete="new-password"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            flexWrap: "wrap",
            gap: 1,
            px: 2,
            pb: 2,
            "& > :not(style) ~ :not(style)": { ml: 0 }, 
          }}
        >
          <Button
            onClick={handleDialogCloseForwarderInfo}
            color="secondary"
            variant="outlined"
            sx={{ flex: { xs: "1 1 calc(50% - 4px)", sm: "0 0 auto" } }}
          >
            Cancel
          </Button>

          <Button
            onClick={() => handleSendForwarderInfo(false)}
            color="secondary"
            variant="contained"
            disabled={!(forwarder.email && forwarder.contact && forwarder.name)}
            sx={{ flex: { xs: "1 1 calc(50% - 4px)", sm: "0 0 auto" } }}
          >
            Save
          </Button>

          <Button
            onClick={() => handleSendForwarderInfo(true)}
            color="secondary"
            variant="contained"
            disabled={
              !(forwarder.email && forwarder.contact && forwarder.name) ||
              !selectedContainerIds.every(
                (c) => c.status === ("OPEN" || "CLOSE"),
              )
            }
            sx={{
              flex: { xs: "1 1 100%", sm: "0 0 auto" },
              whiteSpace: { xs: "normal", sm: "nowrap" },
              lineHeight: 1.3,
            }}
          >
            Save & Close the Container
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openPreview} maxWidth="xl" fullWidth>
        <DialogTitle>Preview Containers</DialogTitle>

        <DialogContent>
          {errors.length > 0 ? (
            <Box>
              <h3 style={{ color: theme.palette.error.main }}>
                Validation Errors
              </h3>
              {errors.map((err, i) => (
                <div key={i} style={{ marginTop: 4 }}>
                  {err}
                </div>
              ))}
            </Box>
          ) : (
            <>
              {creatingContainers && (
                <Box sx={{ width: "100%", mb: 2 }}>
                  <LinearProgress variant="determinate" value={progress} />
                  <div style={{ marginTop: 8 }}>
                    Creating containers... {progress}%
                  </div>
                </Box>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Tooltip title="Export">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDownloadExcel}
                    disabled={!previewData.length}
                  >
                    <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
                  </Button>
                </Tooltip>
              </Box>
              {hasOverVolume && (
                <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    borderRadius: 1,
                    backgroundColor: theme.palette.warning.light,
                    color: theme.palette.warning.contrastText,
                    border: `1px solid ${theme.palette.warning.main}`,
                    fontWeight: 500,
                  }}
                >
                  ⚠️{overVolumeCount} container{overVolumeCount > 1 ? "s" : ""}{" "}
                  exceed the maximum allowed volume. Please correct the data and
                  re-upload the file.
                </Box>
              )}
              {successMessage && (
                <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    borderRadius: 1,
                    backgroundColor: theme.palette.success.light,
                    color: theme.palette.success.contrastText,
                    border: `1px solid ${theme.palette.success.main}`,
                    fontWeight: 500,
                  }}
                >
                  ✅ {successMessage}
                </Box>
              )}
              {errorsList.length > 0 && (
                <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    borderRadius: 1,
                    backgroundColor: theme.palette.error.light,
                    color: theme.palette.error.contrastText,
                    border: `1px solid ${theme.palette.error.main}`,
                  }}
                >
                  <strong>Container Creation Errors:</strong>
                  <ul style={{ marginTop: 8 }}>
                    {errorsList.map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                </Box>
              )}
              <div
                className="ag-theme-alpine"
                style={{ height: "600px", width: "100%" }}
              >
                <AgGridTable
                  gridRef={gridRefPrev}
                  rowData={previewData}
                  columnDefs={previewColumnDefs}
                  defaultColDef={{
                    resizable: true,
                    sortable: true,
                    filter: true,
                    flex: 1,
                  }}
                />
              </div>
            </>
          )}
        </DialogContent>

        <DialogActions>
          {isCreated ? (
            <Button
              variant="outlined"
              onClick={() => {
                setOpenPreview(false);
                setIsCreated(false);
              }}
            >
              Close
            </Button>
          ) : (
            <Button
              variant="outlined"
              onClick={() => {
                setOpenPreview(false);
              }}
            >
              Cancel
            </Button>
          )}

          {errors.length === 0 && !isCreated && (
            <Button
              variant="contained"
              color="success"
              onClick={handleConfirmUpload}
              disabled={creatingContainers || hasOverVolume}
            >
              {creatingContainers ? "Creating..." : "Confirm & Create"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {(loadingExcel || creatingContainers) && (
        <Backdrop open>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Snackbar
        open={openError}
        autoHideDuration={4000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenError(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContainerList;